import type { ILang } from '@core/interfaces/ILang';

const lang: ILang = {
  alert: {
    abort: 'Avortar',
    buy: 'Comprar',
    cancel: 'Cancel·lar',
    caption: 'Error',
    close: 'Tancar',
    confirm: 'Confirmar',
    dont_save: 'No desar',
    dont_show_again: 'No tornar a mostrar',
    duplicated_preset_name: 'Nom preestablert duplicat',
    error: 'UH-OH',
    info: 'INFO',
    instruction: 'Instrucció',
    learn_more: 'Saber-ne més',
    no: 'No',
    ok: "D'acord",
    ok2: "D'acord",
    oops: 'Vaja...',
    retry: 'Reintentar',
    save: 'Desar',
    stop: 'Aturar',
    warning: 'ADVERTÈNCIA',
    yes: 'Sí',
  },
  auto_fit: {
    artwork_size: "Mida de l'obra",
    error_tip1: "1. L'obra està col·locada correctament sobre el material?",
    error_tip2: '2. Els contorns del material són prou clars per al reconeixement?',
    failed_to_find_contour: "No s'han trobat contorns per a l'ajust automàtic",
    learn_more: 'Veure tutorial.',
    learn_more_url: 'https://support.flux3dp.com/hc/en-us/articles/10273384373775',
    offset_x: 'Desplaçament X',
    offset_y: 'Desplaçament Y',
    pattern_size: 'Mida del patró',
    position_artwork: 'Posicionar obra',
    position_step1: 'Ajusta la mida i la posició de la teva obra sobre el patró.',
    position_step2: 'Fes clic a "Aplicar" per aplicar l\'ajust automàtic a aquest patró.',
    preview_first: 'Si us plau, realitza primer la vista prèvia de la càmera.',
    reset_position: 'Restablir posició',
    rotation: 'Rotar',
    select_a_pattern: 'Selecciona un patró',
    selected_artwork: 'Obra seleccionada',
    step1: "Tria un patró on t'agradaria col·locar l'obra.",
    step2: "Si no es troba cap patró, si us plau, torna a fer la vista prèvia de la càmera i aplica l'ajust automàtic.",
    step3: "Si encara no troba el patró correcte, assegura't que la teva peça de treball sigui clarament recognoscible i que l'àrea de treball estigui lliure de residus.",
    title: 'Ajust automàtic',
  },
  barcode_generator: {
    bar_height: 'Alçada de la barra',
    bar_width: 'Amplada de la barra',
    barcode: {
      invalid_value: 'El valor no és vàlid per al format seleccionat.',
    },
    font: 'Tipus de lletra',
    font_size: 'Mida de la lletra',
    hide_text: 'Amagar text',
    invert_color: 'Invertir color',
    text_margin: 'Marge de text',
  },
  beambox: {
    ai_generate: {
      dimensions: {
        more: 'Més',
        ratio: 'Relació',
        resolution: 'Resolució',
        title: 'Dimensions de la imatge',
      },
      error: {
        config_description: 'Error al carregar la configuració de la IA',
        config_message: 'Error al carregar els estils de la IA',
        generation_failed: 'Generació fallida',
        import_failed: 'Importació fallida',
        insufficient_credits: 'Crèdits insuficients',
      },
      form: {
        count: 'Recompte',
        credit_required: 'Crèdit necessari',
        editor: 'Editor',
        generate: 'Generar',
        laser_friendly: 'Apte per a làser',
      },
      header: {
        history_tooltip: 'Historial',
        reset_tooltip: 'Restablir tot',
        title: 'Creació IA',
      },
      history: {
        detail: 'Detall',
        empty_description: 'Encara no hi ha historial de generació. Comença a crear!',
        error_message: "Error al carregar l'historial",
        not_generated: '❌ No generat',
        recreate: 'Recrear',
        status_failed: 'Fallit',
        status_generating: 'Generant',
        status_success: 'Èxit',
        storage_notice: 'Es guarden fins a 10 registres recents. Les imatges generades es mantenen durant 3 dies.',
        title: 'Historial de generació',
      },
      loading: {
        history: 'Carregant historial...',
        styles: 'Carregant estils IA...',
        tip_0: 'Escalfant el motor creatiu...',
        tip_1: 'Polint píxels... ✨',
        tip_2: 'Gairebé hi som, refinant els detalls',
        tip_3: 'Encara treballant, aquesta part necessita una mica més de temps',
        tip_4: 'Les grans idees prenen temps, gràcies per quedar-te aquí',
      },
      results: {
        download: 'Descarregar',
        import: 'Importar',
        title: 'Resultats',
      },
      retry: 'Reintentar',
      style: {
        apply: 'Aplicar estil',
        choose: 'Tria estil',
        custom_creation: 'Creació personalitzada',
        customize: 'Personalitzar',
        select: 'Selecciona estil de creació',
      },
      upload: {
        add: 'Afegir',
        click_or_drag: 'Fes clic o arrossega imatges aquí',
        error: 'Error de pujada',
        file_size_error: '%s: La mida del fitxer ha de ser inferior a %sMB',
        file_type_error: "%s: Només s'admeten imatges JPEG, PNG i WebP",
        from_history: "De l'historial",
        images: 'Pujar imatges',
        max_images_error: 'Màxim %s imatges permeses',
        selected: '%s / %s seleccionats',
        supported_formats: 'JPEG, PNG, WebP • Màx %s',
      },
      validation: {
        description_or_image_required: 'Si us plau, proporciona una descripció o puja almenys una imatge',
        field_exceeds_max_length: '"%s" supera la longitud màxima de %s caràcters.',
        field_required: '"%s" és obligatori. Si us plau, omple aquest camp.',
        login_required: 'Si us plau, inicia sessió per utilitzar la generació IA.',
        max_images: 'Màxim %s imatges permeses',
      },
    },
    announcement_panel: {
      title: 'Anunci',
    },
    banner: {
      auto_feeder: 'Mode alimentador automàtic',
      autofocus1: 'Mode enfocament automàtic',
      autofocus2: "Fes clic a qualsevol lloc per realitzar l'enfocament automàtic.",
      camera_preview_borderless_mode: '(Fons obert)',
      curve_engraving: 'Mode gravat corbat',
      pass_through: 'Mode pas a través',
      rotary: 'Mode rotatori',
    },
    bottom_right_panel: {
      convert_text_to_path_before_export: 'Convertir text a traçat...',
      export_file_error_ask_for_upload: "Error al exportar la tasca. Estàs disposat a proporcionar l'escena de treball a l'equip de desenvolupament per a l'informe d'errors?",
      retreive_image_data: "Recuperar dades d'imatge...",
    },
    context_menu: {
      copy: 'Copiar',
      cut: 'Retallar',
      delete: 'Eliminar',
      duplicate: 'Duplicar',
      group: 'Agrupar',
      move_back: 'Enviar al fons',
      move_down: 'Enviar enrere',
      move_front: 'Portar al davant',
      move_up: 'Portar endavant',
      paste: 'Enganxar',
      paste_in_place: 'Enganxar al lloc',
      ungroup: 'Desagrupar',
    },
    document_panel: {
      add_on: 'Complements',
      auto_feeder: 'Alimentador automàtic',
      auto_feeder_url: 'https://support.flux3dp.com/hc/en-us/articles/11688230498575',
      auto_shrink: 'Contracció automàtica',
      auto_shrink_tooltip: "Només s'aplica a capes amb una resolució superior o igual a 250 DPI.",
      auto_shrink_url: 'https://support.flux3dp.com/hc/en-us/articles/12997377035919',
      borderless_mode: 'Fons obert',
      current_position: 'Posició actual',
      disable: 'Deshabilitar',
      document_settings: 'Configuració del document',
      door_protect: 'Protecció de porta',
      door_protect_desc: 'Disponible només amb Promark Safe+.',
      enable_autofocus: 'Enfocament automàtic',
      enable_diode: 'Làser de díode',
      enable_nozzle_refresh_area: 'Habilitar àrea de refresc del broquet',
      extend_y_area: 'Estendre àrea Y',
      frame_before_start: "Emmarcar abans d'executar",
      frame_before_start_url: 'https://support.flux3dp.com/hc/en-us/articles/11494925637135',
      job_origin: 'Origen del treball',
      laser_source: 'Font làser',
      machine: 'Màquina',
      manual: 'Manual',
      notification: {
        changeFromPrintingWorkareaTitle: "Vols convertir les capes d'impressió en capes làser?",
      },
      origin: 'Origen',
      pass_through: 'Pas a través',
      pass_through_height_desc: "Introdueix la longitud de l'objecte per estendre l'àrea de treball.",
      rotary_mode: 'Rotatori',
      scale: 'Escala',
      skip_prespray: 'Ometre purga',
      start_from: 'Començar des de',
      start_position: "Posició d'inici",
      start_work_button: "Botó d'execució",
      workarea: 'Àrea de treball',
    },
    elements_panel: {
      animals: 'Animal',
      arrow: 'Fletxa',
      avatar: 'Avatar',
      basic: 'Bàsic',
      birds: 'Ocell',
      browse_categories: 'Explorar categories',
      celebration: 'Celebració',
      circular: 'Circular',
      cleaning_tools: 'Eines de neteja',
      CNY: 'Any Nou Lunar',
      corner: 'Cantonada',
      decor: 'Decoració',
      doctor: 'Metge',
      easter: 'Pasqua',
      elements: 'Elements',
      environment: 'Medi ambient',
      gardening_tools: 'Eines de jardineria',
      graphics: 'Gràfics',
      halloween: 'Halloween',
      hammer_wrench: 'Martell i clau anglesa',
      heart: 'Cor',
      holidays: 'Festius',
      insect: 'Insecte',
      kitchen_tools: 'Eines de cuina',
      label: 'Etiqueta',
      land: 'Terra',
      line: 'Línia',
      load_more: 'Carregar els següents 100 resultats',
      nature: 'Natura',
      people: 'Gent',
      photo: 'Foto',
      plants: 'Planta',
      police: 'Policia',
      recently_used: 'Usat recentment',
      ribbon: 'Cinta',
      sea: 'Mar',
      search_examples: 'Exemples:',
      search_invalid_characters: 'Caràcters no vàlids utilitzats.',
      search_no_results: 'No s\'han trobat resultats per a "%s". Si us plau, comprova l\'ortografia o prova amb una paraula clau diferent.',
      search_with_english: 'Només es permeten lletres angleses, números, comes i espais.',
      shape: 'Forma',
      sign_in: 'Inicia sessió per obtenir més de 10.000 icones gratuïtes',
      speech: 'Discurs',
      student: 'Estudiant',
      study_tools: "Eines d'estudi",
      teacher: 'Professor',
      text: 'Marc de text',
      title: 'Elements',
      tools: 'Eines',
      valentines: 'Sant Valentí',
      weather: 'Meteorologia',
      Xmas: 'Nadal',
    },
    image_trace_panel: {
      back: 'Enrere',
      brightness: 'Brillantor',
      cancel: 'Cancel·lar',
      contrast: 'Contrast',
      next: 'Següent',
      okay: "D'acord",
      threshold: 'Llindar',
      tuning: 'Paràmetres',
    },
    layer_color_config_panel: {
      add: 'Afegir',
      add_config: 'Afegir color',
      color: 'Color',
      default: 'Restablir per defecte',
      in_use: 'Aquest color està en ús.',
      layer_color_config: 'Configuracions de color de capa',
      no_input: 'Si us plau, introdueix un codi de color hexadecimal vàlid.',
      power: 'Potència',
      repeat: 'Executar',
      speed: 'Velocitat',
      sure_to_delete: "Estàs segur d'eliminar aquesta configuració de color?",
      sure_to_reset: 'Perdràs tots els paràmetres personalitzats, estàs segur de restablir per defecte?',
    },
    left_panel: {
      borderless_blind_area: 'Àrea sense gravat',
      borderless_preview: 'Vista prèvia de càmera mode fons obert',
      diode_blind_area: 'Àrea cega complement làser híbrid',
      label: {
        adjust_height: 'Ajustar alçada',
        array: 'Matriu',
        boxgen: 'Generador de caixes',
        choose_camera: 'Càmera',
        clear_preview: 'Esborrar vista prèvia',
        cursor: 'Seleccionar',
        curve_engraving: {
          clear_area: 'Esborrar àrea seleccionada',
          exit: 'Sortir',
          preview_3d_curve: 'Vista prèvia gravat corbat',
          select_area: 'Seleccionar àrea',
          title: 'Gravat corbat',
        },
        elements: 'Elements',
        end_preview: 'Finalitzar vista prèvia',
        line: 'Línia',
        live_feed: 'Transmissió en directe',
        my_cloud: 'El meu núvol',
        oval: 'Oval',
        pass_through: 'Pas a través',
        pen: 'Bolígraf',
        photo: 'Imatge',
        polygon: 'Polígon',
        preview: 'Vista prèvia de càmera',
        preview_wide_angle: 'Vista prèvia de càmera gran angular',
        qr_code: 'Codi QR',
        rect: 'Rectangle',
        text: 'Text',
        trace: 'Traçar imatge',
      },
      unpreviewable_area: 'Àrea cega',
    },
    network_testing_panel: {
      average_response: 'Temps mitjà de resposta',
      cannot_connect_1: "#840 Error en connectar a l'IP objectiu.",
      cannot_connect_2: "#840 Error en connectar a l'IP objectiu. Si us plau, assegura't que l'objectiu està a la mateixa xarxa.",
      cannot_get_local: "Accés a l'adreça IP local fallit.",
      connection_quality: 'Qualitat de connexió',
      device_not_on_list: '#842 La màquina no és a la llista, però la qualitat de connexió és >70 i el temps mitjà de resposta és <100ms',
      empty_ip: "#818 Si us plau, introdueix primer l'IP del dispositiu objectiu.",
      end: 'Fi',
      fail_to_start_network_test: '#817 Error en iniciar la prova de xarxa.',
      hint_connect_camera_timeout: "Temps d'espera superat en iniciar la vista prèvia de la càmera?",
      hint_connect_failed_when_sending_job: 'Error en connectar en enviar un treball?',
      hint_device_often_on_list: 'La màquina sovint no es troba a la llista?',
      insert_ip: 'Adreça IP del dispositiu objectiu:',
      invalid_ip: '#818 Adreça IP no vàlida',
      ip_startswith_169: "#843 L'adreça IP de la màquina comença amb 169.254",
      link_connect_camera_timeout: 'https://support.flux3dp.com/hc/en-us/articles/360001791895',
      link_connect_failed_when_sending_job: 'https://support.flux3dp.com/hc/en-us/articles/360001841656',
      link_device_often_on_list: 'https://support.flux3dp.com/hc/en-us/articles/360001841636',
      linux_permission_hint: 'Aquest error sol produir-se per permisos insuficients.\nSi us plau, executa "sudo beam-studio --no-sandbox" a la terminal per obtenir permisos i realitzar la prova de xarxa.',
      local_ip: 'Adreça IP local:',
      network_testing: 'Prova de xarxa',
      network_unhealthy: '#841 Qualitat de connexió <70 o temps mitjà de resposta >100ms',
      start: 'Inici',
      test_completed: 'Prova completada',
      test_fail: 'Prova fallida',
      testing: 'Provant xarxa...',
    },
    object_panels: {
      lock_desc: "Preservar la relació d'amplada i alçada (SHIFT)",
      text_to_path: {
        check_thumbnail_warning: "Alguns textos s'han canviat a altres fonts en analitzar textos a traçats i algun caràcter pot no convertir-se normalment.\nSi us plau, comprova la imatge de vista prèvia de nou abans d'enviar la tasca.",
        error_when_parsing_text: 'Error en convertir text a traçat',
        font_substitute_pop: 'El teu text conté caràcters que no són compatibles amb la font actual. <br/>Vols utilitzar <strong>%s</strong> com a substitució?',
        retry: 'Si us plau, torna-ho a provar més tard o tria una altra font',
        use_current_font: 'Utilitzar font actual',
      },
      wait_for_parsing_font: 'Analitzant font... Si us plau, espera un segon',
    },
    path_preview: {
      current_position: 'Posició actual',
      cut_distance: 'Distància de tall',
      cut_time: 'Temps de tall',
      end_preview: 'Finalitzar vista prèvia',
      estimated_time: 'Temps total estimat',
      invert: 'Invertir',
      pause: 'Pausa',
      play: 'Reproduir',
      play_speed: 'Velocitat de reproducció',
      preview_info: 'Informació de vista prèvia',
      rapid_distance: 'Distància de viatge',
      rapid_time: 'Temps de viatge',
      remark: '* Tota la informació és un valor estimat de referència.',
      size: 'Mida',
      start_here: 'Començar aquí',
      stop: 'Aturar',
      travel_path: 'Camí de viatge',
    },
    photo_edit_panel: {
      aspect_ratio: "Relació d'aspecte",
      brightness: 'Brillantor',
      brightness_and_contrast: 'Brillantor / Contrast',
      circumference: 'Circumferència',
      compare: 'Comparar',
      contrast: 'Contrast',
      crop: 'Retallar',
      curve: 'Corba',
      diameter: 'Diàmetre',
      free: 'Lliure',
      invert: 'Invertir color',
      original: 'Original',
      phote_edit: 'Edició de foto',
      processing: 'Processant',
      radius: 'Radi',
      rotary_warped: 'Rotatori deformat',
      rotary_warped_link: 'https://support.flux3dp.com/hc/en-us/articles/10828006201103',
      sharpen: 'Afilar',
      sharpness: 'Nitidesa',
      start: 'Inici',
      warp: 'Deformar',
    },
    popup: {
      ai_credit: {
        buy_link: 'https://member.flux3dp.com/en-US/credit',
        insufficient_credit: 'Crèdit insuficient',
        insufficient_credit_msg: 'Aquesta funció requereix %s Crèdits IA, però només et queden %s Crèdits IA. \nSi us plau, compra més crèdits i torna-ho a provar.',
        relogin_to_use: 'Si us plau, torna a iniciar sessió per utilitzar aquesta funció.',
      },
      auto_feeder_origin: "Si us plau, utilitza la vista prèvia d'emmarcat per comprovar el camí i l'àrea del capçal làser, després ajusta la col·locació del material o la posició d'inici de gravat segons els resultats per evitar col·lisions durant el procés de gravat.",
      auto_switch_tab: {
        message: "S'ha afegit una nova opció per canviar automàticament entre el panell de Capes i el panell d'Objectes a Preferències. Aquesta opció està desactivada per defecte. Vols habilitar el canvi automàtic ara?<br/>Pots canviar aquesta configuració en qualsevol moment a Preferències.",
        title: 'Canvi automàtic panell Capa i Objecte',
      },
      backend_connect_failed_ask_to_upload: "#802 Es produeixen errors en intentar connectar al backend. Vols pujar el teu registre d'informe d'errors?",
      backend_error_hint: "Les funcions poden no funcionar correctament a causa d'un error de backend.",
      both_power_and_speed_too_high: 'Utilitzar una potència làser més baixa allargarà la vida útil del tub làser.\nA més, una velocitat massa alta en aquesta resolució pot resultar en una qualitat inferior del gravat ombrejat.',
      bug_report: "Informe d'errors",
      change_workarea_before_preview: "L'àrea de treball de %s no coincideix amb l'àrea de treball establerta actualment. Vols canviar l'àrea de treball actual?",
      convert_to_path_fail: 'Error al convertir a traçat.',
      disassemble_use: {
        clip_path_warning: 'Aquest fitxer conté una màscara de retall i no es pot desmuntar.',
        execute_time_warning: "Això desagruparà el DXF o SVG importat. Com que el fitxer pot contenir un gran nombre d'elements, pot trigar temps a desagrupar-se. Estàs segur de procedir?",
      },
      dxf_bounding_box_size_over: "La mida del dibuix està fora de l'àrea de treball. Si us plau, mou el teu dibuix més a prop de l'origen al teu programari CAD, o assegura't que la unitat estigui configurada correctament.",
      dxf_version_waring: "La versió d'aquest fitxer DXF no és 2013, hi pot haver problemes d'incompatibilitat potencials.",
      facebook_group_invitation: {
        already_joined: 'Ja unit',
        join_now: 'Compta amb mi',
        later: 'Potser més tard',
        message: "Uneix-te al nostre grup oficial de Facebook per connectar amb altres usuaris de làser FLUX, parlar de làsers FLUX, compartir obres d'art làser i estar al dia de les últimes actualitzacions dels nostres productes. No podem esperar a veure't allà!",
        title: "Uneix-te al grup oficial d'usuaris FLUX",
      },
      failed_to_load_svg: "No s'han pogut carregar les dades SVG",
      import_file_contain_invalid_path: "#808 El fitxer SVG importat conté una ruta d'imatge no vàlida. Si us plau, assegura't que tots els fitxers d'imatge existeixin o incrusta la imatge al fitxer",
      import_file_error_ask_for_upload: "Error al importar fitxer SVG. Estàs disposat a proporcionar el fitxer a l'equip de desenvolupament per a l'informe d'errors?",
      import_svg: {
        advice_message: "Això pot causar un retard greu o fallada d'importació.",
        advice_message_2: "Es recomana simplificar el fitxer abans d'importar.",
        confirmation_message: 'Vols procedir?',
        element_count_warning: "Nombre d'elements: %s (Recomanat: < %s).",
        file_size_warning: 'Mida del fitxer: %sMB (Recomanat: < %sMB).',
        intro_message: 'El fitxer pot ser massa gran o complex:',
        path_d_command_count_warning: 'Nombre de comandes: %s (Recomanat: < %s).',
        title: "Advertència d'importació de fitxer",
      },
      layer_by_color: 'Color',
      layer_by_layer: 'Capa',
      loading_image: 'Carregant imatge, si us plau espera...',
      more_than_two_object: 'Massa objectes. Només suport per a 2 objectes',
      mouse: 'Ratolí',
      no_curve_engraving_with_modules: "Aquest treball inclou gravat de superfície corba, que no es pot utilitzar juntament amb la impressió en color. Si us plau, desactiva la capa d'impressió en color i torna a enviar el treball.",
      no_support_text: "Beam Studio no admet etiqueta de text actualment. Si us plau, transfereix text a traçat abans d'importar.",
      nolayer: 'Capa única',
      not_support_object_type: "Tipus d'objecte no admès",
      or_turn_off_borderless_mode: ' O desactiva el mode Fons obert.',
      path_engine_upgrade: {
        caption: 'Generació de treballs més ràpida disponible',
        keep_current: 'Mantenir actual',
        message: 'Hem actualitzat el motor de càlcul de treballs per millorar el rendiment i accelerar la generació de treballs.\nVoleu canviar al nou motor accelerat?\nPodeu desactivar-lo en qualsevol moment a %(preferences)s > %(editor)s > %(path_acceleration)s.',
      },
      pdf2svg: {
        error_pdf2svg_not_found: '#825 Error: Comanda pdf2svg no trobada. Si us plau, instal·la pdf2svg amb el teu gestor de paquets (p. ex., "yum install pdf2svg" o "apt-get install pdf2svg").',
        error_when_converting_pdf: '#824 Error en convertir PDF a SVG:',
      },
      progress: {
        calculating: 'Calculant',
        uploading: 'Pujant',
      },
      questionnaire: {
        caption: "Ajuda'ns a omplir el qüestionari",
        message: "Ajuda'ns a omplir el qüestionari per millorar Beam Studio.",
        no_questionnaire_available: 'No hi ha cap qüestionari disponible ara mateix.',
        unable_to_get_url: "Error en obtenir l'enllaç al qüestionari via internet. Si us plau, confirma la teva connexió a internet.",
      },
      reach_tab_count_limit: "S'ha arribat al límit de recompte de pestanyes",
      recommend_downgrade_software: 'Hem detectat una versió de firmware més antiga. Estem abordant activament els problemes de compatibilitat, però per ara, recomanem tornar a <a target="_blank" href="https://beamstudio.s3.ap-northeast-1.amazonaws.com/mac/Beam+Studio+1.9.5.dmg">Beam Studio 1.9.5</a>.',
      recommend_upgrade_firmware: "Hem detectat una versió de firmware més antiga. Estem abordant activament els problemes de compatibilitat, però per ara, recomanem actualitzar a l'últim firmware.",
      save_unsave_changed: 'Vols desar els canvis no desats?',
      select_at_least_two: 'Selecciona dos objectes per procedir',
      select_first: 'Selecciona un objecte primer.',
      select_import_method: 'Selecciona estil de capes:',
      select_import_module: 'Selecciona mòdul:',
      sentry: {
        message: "Estàs d'acord en pujar automàticament informació rellevant a l'equip de desenvolupament quan es produeixin errors?",
        title: 'Fem Beam Studio millor junts',
      },
      should_update_firmware_to_continue: '#814 El teu firmware no admet aquesta versió de Beam Studio. Si us plau, actualitza el firmware per continuar. (Menú > Màquina > [La teva màquina] > Actualitzar firmware)',
      speed_too_high_lower_the_quality: 'Utilitzar una velocitat massa alta en aquesta resolució pot resultar en una qualitat inferior del gravat ombrejat.',
      still_continue: 'Continuar',
      successfully_uploaded: 'Pujada de fitxer reeixida.',
      svg_1_1_waring: "La versió d'aquest fitxer SVG és v 1.1, hi pot haver problemes d'incompatibilitat potencials.",
      svg_image_path_waring: 'Aquest fitxer SVG conté <image> carregant des de la ruta del fitxer. Això pot causar fallades en carregar.\nPer evitar aquest risc, si us plau, utilitza imatge incrustada en exportar SVG.',
      text_to_path: {
        caption: 'Convertidor Text a Traçat 2.0',
        message: "Beam Studio ara introdueix un nou convertidor de text a traçat (Convertidor 2.0), que produeix resultats més fiables! Vols canviar-hi ara? \nTambé pots ajustar aquesta configuració més tard a la secció 'Convertidor Text a Traçat' dins de les preferències.",
      },
      too_fast_for_auto_feeder: 'Utilitzar una velocitat massa alta en capes que contenen objectes de traçat pot resultar en una precisió inferior en tallar.\nNo recomanem utilitzar una velocitat superior a %(limit)s quan es talla amb Alimentador automàtic.',
      too_fast_for_auto_feeder_and_constrain: 'Les següents capes: %(layers)s \ncontenen objectes de traçat vectorial, i tenen una velocitat superior a %(limit)s.\nLa velocitat de tall dels objectes de traçat vectorial amb Alimentador automàtic es restringirà a %(limit)s.\nPots eliminar aquest límit a Configuració de preferències.',
      too_fast_for_curve: 'En mode de gravat corbat, la velocitat actual pot ser massa alta i podria afectar els detalls del gravat de les capes: %(layers)s.\nConsidereu reduir la velocitat per obtenir una millor qualitat.',
      too_fast_for_path: 'Utilitzar una velocitat massa alta en capes que contenen objectes de traçat pot resultar en una precisió inferior en tallar.\nNo recomanem utilitzar una velocitat superior a %(limit)s quan es talla.',
      too_fast_for_path_and_constrain: 'Les següents capes: %(layers)s \ncontenen objectes de traçat vectorial, i tenen una velocitat superior a %(limit)s.\nLa velocitat de tall dels objectes de traçat vectorial es restringirà a %(limit)s.\nPots eliminar aquest límit a Configuració de preferències.',
      touchpad: 'Panell tàctil',
      upload_failed: '#819 Error de pujada de fitxer.',
      upload_file_too_large: '#819 El fitxer és massa gran per pujar.',
      vectorize_shading_image: "Les imatges amb degradat triguen més temps a traçar i són propenses al soroll. Si us plau, desactiva el degradat de la imatge abans d'executar.",
    },
    rating_panel: {
      description: "Si t'agrada Beam Studio, agrairíem molt si ens poguessis valorar.",
      thank_you: 'Gràcies!',
      title: 'Gaudeixes de Beam Studio?',
    },
    right_panel: {
      laser_panel: {
        advanced: 'Avançat',
        air_assist: "Assistència d'aire",
        am_density: 'Densitat AM',
        backlash: 'Joc',
        bi_directional: 'Bidireccional',
        by: 'Per',
        ce_z_high_speed: "Eix Z d'alta velocitat",
        ce_z_high_speed_link: 'https://support.flux3dp.com/hc/en-us/articles/10364060644495',
        color_adjustment: 'Ajust de canal',
        color_adjustment_short: 'Canal',
        color_strength: 'Força',
        cross_hatch: 'Traçat creuat',
        custom_preset: 'Personalitzat',
        cut: 'Tallar',
        diode: 'Làser de díode',
        do_not_adjust_default_para: 'Els preestablerts no es poden ajustar.',
        dottingTime: 'Temps de puntejat',
        dropdown: {
          inches: {
            abs_engraving: 'ABS - Gravat',
            acrylic_3mm_cutting: 'Acrílic - Tall 1/8″',
            acrylic_5mm_cutting: 'Acrílic - Tall 3/16″',
            acrylic_7mm_cutting: 'Acrílic - Tall 1/4″',
            acrylic_8mm_cutting: 'Acrílic - Tall 1/4″',
            acrylic_10mm_cutting: 'Acrílic - Tall 3/8″',
            acrylic_engraving: 'Acrílic - Gravat',
            acrylic_printing: 'Acrílic - Impressió',
            aluminum_engraving: 'Alumini - Gravat',
            aluminum_light: 'Alumini (clar)',
            bamboo_2mm_cutting: 'Bambú - Tall 5/64″',
            bamboo_5mm_cutting: 'Bambú - Tall 3/16″',
            bamboo_printing: 'Bambú - Impressió',
            black_abs: 'ABS negre',
            black_acrylic_3mm_cutting: 'Acrílic negre - Tall 1/8″',
            black_acrylic_5mm_cutting: 'Acrílic negre - Tall 3/16″',
            black_acrylic_engraving: 'Acrílic negre - Gravat',
            brass_dark: 'Llautó (fosc)',
            brass_engraving: 'Llautó - Gravat',
            brass_light: 'Llautó (clar)',
            canvas_fabric_printing: 'Teixit de lona - Impressió',
            canvas_printing: 'Lona - Impressió',
            cardboard_printing: 'Cartró - Impressió',
            cardstock_printing: 'Cartolina - Impressió',
            copper: 'Coure',
            cork_printing: 'Suro - Impressió',
            denim_1mm_cutting: 'Texà - Tall 1/32″',
            fabric_3mm_cutting: 'Tela - Tall 1/8″',
            fabric_5mm_cutting: 'Tela - Tall 3/16″',
            fabric_engraving: 'Tela - Gravat',
            fabric_printing: 'Tela - Impressió',
            flat_stone_printing: 'Pedra plana - Impressió',
            glass_bw_engraving: 'Vidre - Gravat',
            glass_printing: 'Vidre - Impressió',
            gloss_leather_printing: 'Cuir brillant - Impressió',
            gold_engraving: 'Or - Gravat',
            iron_engraving: 'Ferro - Gravat',
            leather_3mm_cutting: 'Cuir - Tall 1/8″',
            leather_5mm_cutting: 'Cuir - Tall 3/16″',
            leather_engraving: 'Cuir - Gravat',
            leather_printing: 'Cuir - Impressió',
            mdf_3mm_cutting: 'MDF Nova Zelanda - Tall 1/8″',
            mdf_5mm_cutting: 'MDF Nova Zelanda - Tall 3/16″',
            mdf_7mm_cutting: 'MDF Nova Zelanda - Tall 1/4″',
            mdf_engraving: 'MDF Nova Zelanda - Gravat',
            mdf_printing: 'MDF Nova Zelanda - Impressió',
            metal_bw_engraving: 'Metall - Gravat',
            opaque_acrylic: 'Acrílic opac',
            pc_printing: 'PC - Impressió',
            rubber_bw_engraving: 'Goma - Gravat',
            silver_engraving: 'Plata - Gravat',
            slate_engraving: 'Pissarra - Gravat',
            stainless_steel_bw_engraving_diode: 'Metall - Gravat (Làser de díode)',
            stainless_steel_dark: 'Acer inoxidable (fosc)',
            stainless_steel_engraving: 'Acer inoxidable - Gravat',
            stainless_steel_light: 'Acer inoxidable (clar)',
            stainless_steel_printing: 'Acer inoxidable - Impressió',
            steel_engraving_spray_engraving: 'Metall - Gravat',
            sticker_kiss_cut: 'Adhesiu – Tall superficial',
            sticker_printing: 'Adhesiu – Impressió',
            stone: 'Pedra',
            ti_engraving: 'Titani - Gravat',
            titanium_dark: 'Titani (fosc)',
            titanium_light: 'Titani (clar)',
            white_abs: 'ABS blanc',
            wood_3mm_cutting: 'Fusta - Tall 1/8″',
            wood_5mm_cutting: 'Fusta - Tall 3/16″',
            wood_7mm_cutting: 'Fusta - Tall 1/4″',
            wood_8mm_cutting: 'Fusta - Tall 1/4″',
            wood_10mm_cutting: 'Fusta - Tall 3/8″',
            wood_engraving: 'Fusta - Gravat',
            wood_printing: 'Fusta - Impressió',
          },
          mm: {
            abs_engraving: 'ABS - Gravat',
            acrylic_3mm_cutting: 'Acrílic - Tall 3mm',
            acrylic_5mm_cutting: 'Acrílic - Tall 5mm',
            acrylic_7mm_cutting: 'Acrílic - Tall 7mm',
            acrylic_8mm_cutting: 'Acrílic - Tall 8mm',
            acrylic_10mm_cutting: 'Acrílic - Tall 10mm',
            acrylic_engraving: 'Acrílic - Gravat',
            acrylic_printing: 'Acrílic - Impressió',
            aluminum_engraving: 'Alumini - Gravat',
            aluminum_light: 'Alumini (clar)',
            bamboo_2mm_cutting: 'Bambú - Tall 2mm',
            bamboo_5mm_cutting: 'Bambú - Tall 5mm',
            bamboo_printing: 'Bambú - Impressió',
            black_abs: 'ABS negre',
            black_acrylic_3mm_cutting: 'Acrílic negre - Tall 3mm',
            black_acrylic_5mm_cutting: 'Acrílic negre - Tall 5mm',
            black_acrylic_engraving: 'Acrílic negre - Gravat',
            brass_dark: 'Llautó (fosc)',
            brass_engraving: 'Llautó - Gravat',
            brass_light: 'Llautó (clar)',
            canvas_fabric_printing: 'Teixit de lona - Impressió',
            canvas_printing: 'Lona - Impressió',
            cardboard_printing: 'Cartró - Impressió',
            cardstock_printing: 'Cartolina - Impressió',
            copper: 'Coure',
            cork_printing: 'Suro - Impressió',
            denim_1mm_cutting: 'Texà - Tall 1mm',
            fabric_3mm_cutting: 'Tela - Tall 3mm',
            fabric_5mm_cutting: 'Tela - Tall 5mm',
            fabric_engraving: 'Tela - Gravat',
            fabric_printing: 'Tela - Impressió',
            flat_stone_printing: 'Pedra plana - Impressió',
            glass_bw_engraving: 'Vidre - Gravat',
            glass_printing: 'Vidre - Impressió',
            gloss_leather_printing: 'Cuir brillant - Impressió',
            gold_engraving: 'Or - Gravat',
            iron_engraving: 'Ferro - Gravat',
            leather_3mm_cutting: 'Cuir - Tall 3mm',
            leather_5mm_cutting: 'Cuir - Tall 5mm',
            leather_engraving: 'Cuir - Gravat',
            leather_printing: 'Cuir - Impressió',
            mdf_3mm_cutting: 'MDF Nova Zelanda - Tall 3mm',
            mdf_5mm_cutting: 'MDF Nova Zelanda - Tall 5mm',
            mdf_7mm_cutting: 'MDF Nova Zelanda - Tall 7mm',
            mdf_engraving: 'MDF Nova Zelanda - Gravat',
            mdf_printing: 'MDF Nova Zelanda - Impressió',
            metal_bw_engraving: 'Metall - Gravat',
            opaque_acrylic: 'Acrílic opac',
            pc_printing: 'PC - Impressió',
            rubber_bw_engraving: 'Goma - Gravat',
            silver_engraving: 'Plata - Gravat',
            slate_engraving: 'Pissarra - Gravat',
            stainless_steel_bw_engraving_diode: 'Metall - Gravat (Làser de díode)',
            stainless_steel_dark: 'Acer inoxidable (fosc)',
            stainless_steel_engraving: 'Acer inoxidable - Gravat',
            stainless_steel_light: 'Acer inoxidable (clar)',
            stainless_steel_printing: 'Acer inoxidable - Impressió',
            steel_engraving_spray_engraving: 'Metall - Gravat',
            sticker_kiss_cut: 'Adhesiu – Tall superficial',
            sticker_printing: 'Adhesiu – Impressió',
            stone: 'Pedra',
            ti_engraving: 'Titani - Gravat',
            titanium_dark: 'Titani (fosc)',
            titanium_light: 'Titani (clar)',
            white_abs: 'ABS blanc',
            wood_3mm_cutting: 'Fusta - Tall 3mm',
            wood_5mm_cutting: 'Fusta - Tall 5mm',
            wood_7mm_cutting: 'Fusta - Tall 7mm',
            wood_8mm_cutting: 'Fusta - Tall 8mm',
            wood_10mm_cutting: 'Fusta - Tall 10mm',
            wood_engraving: 'Fusta - Gravat',
            wood_printing: 'Fusta - Impressió',
          },
          parameters: 'Preestablerts',
          save: 'Afegir paràmetres actuals',
        },
        engrave: 'Gravar',
        existing_name: "Aquest nom ja s'ha utilitzat.",
        fill_angle: 'Angle de farciment',
        fill_interval: 'Interval de farciment',
        fill_setting: 'Configuració de farciment',
        filled_path_only: 'Només per a camins de farciment',
        focus_adjustment: "Ajust d'enfocament",
        frequency: 'Freqüència',
        gradient_only: 'Només per a imatges amb degradat',
        halftone: 'Mitjos tons',
        halftone_link: 'https://support.flux3dp.com/hc/en-us/articles/9402670389647',
        height: "Alçada de l'objecte",
        ink_saturation: 'Saturació',
        low_air_assist_warning: "Es recomana establir l'assistència d'aire per sobre del 50% per reduir eficaçment el risc que el material s'incendiï.",
        low_power_warning: 'Una potència làser més baixa (menys del 10%) podria no emetre la llum làser.',
        low_speed_warning: 'Una velocitat baixa podria causar cremades al material.',
        lower_focus: 'Baixar enfocament',
        lower_focus_desc: "Baixar l'alçada d'enfocament una distància específica després d'enfocar per millorar el rendiment de tall.",
        module: 'Mòdul',
        more: 'Gestionar',
        multi_layer: 'Múltiples capes',
        para_in_use: "Aquest paràmetre s'està utilitzant.",
        parameters: 'Paràmetres',
        preset_management: {
          add_new: 'Afegir nou',
          delete: 'Eliminar',
          export: 'Exportar',
          export_preset_title: 'Exportar preestablerts',
          import: 'Importar',
          laser: 'Làser',
          lower_focus_by: 'Baixar enfocament per',
          new_preset_name: 'Nom nou preestablert',
          preset: 'Preestablert',
          print: 'Imprimir',
          reset: 'Restablir',
          save_and_exit: 'Desar i sortir',
          show_all: 'Mostrar tot',
          sure_to_import_presets: 'Això carregarà la disposició dels preestablerts i sobreescriurà els paràmetres personalitzats, estàs segur de procedir?',
          sure_to_reset: 'Això eliminarà els teus paràmetres personalitzats i restablirà tots els preestablerts, estàs segur de procedir?',
          title: 'Gestionar paràmetres',
          wobble_diameter: 'Diàmetre de wobble',
          wobble_step: 'Mida de pas de wobble',
        },
        preset_setting: 'Configuració de paràmetres (%s)',
        presets: 'Preestablert',
        print_multipass: 'Multi-passada',
        promark_speed_desc: 'Els paràmetres de velocitat no són aplicables a imatges amb degradat.',
        pulse_width: 'Amplada de pols',
        pwm_advanced_desc: 'Establir una potència mínima per al Mode Profunditat.',
        pwm_advanced_hint: "Aquesta configuració s'aplica específicament a imatges amb degradat quan s'utilitza el Mode Profunditat.",
        pwm_advanced_setting: 'Configuració de potència Mode Profunditat',
        refresh_interval: 'Interval de refresc',
        refresh_printer: "Refresc capçal d'impressió",
        repeat: 'Recompte de passades',
        single_color: 'Color únic',
        single_color_desc: 'Només aplicable a capa a tot color i no es pot utilitzar amb capa de color únic expandida.',
        slider: {
          fast: 'Ràpid',
          high: 'Alt',
          low: 'Baix',
          regular: 'Regular',
          slow: 'Lent',
          very_fast: 'El més ràpid',
          very_high: 'Màx',
          very_low: 'Mín',
          very_slow: 'El més lent',
        },
        speed: 'Velocitat',
        speed_constrain_warning: 'La velocitat de tall dels objectes de traçat vectorial es restringirà a %(limit)s. Pots eliminar aquest límit a Configuració de preferències.',
        speed_constrain_warning_auto_feeder: "La velocitat de tall dels objectes d'Alimentador automàtic es restringirà a %(limit)s. Pots eliminar aquest límit a Configuració de preferències.",
        speed_constrain_warning_curve_engraving: 'La velocitat dels objectes de gravat corbat es restringirà a %(limit)s. Pots eliminar aquest límit a Configuració de preferències.',
        speed_constrain_warning_module_addon: 'En utilitzar un mòdul complementari, evita velocitats superiors a %(limit)s per mantenir la qualitat del gravat.',
        stepwise_focusing: 'Enfocament esglaonat',
        stepwise_focusing_desc: "Baixar gradualment la distància d'enfocament basat en l'alçada de l'objecte durant cada recompte de passada.",
        strength: 'Potència',
        times: 'vegades',
        various_preset: 'Diversos preestablerts',
        white_ink: 'Tinta blanca',
        white_ink_settings: 'Configuració de tinta blanca',
        wobble: 'Wobble',
        wobble_desc: 'Crea cercles diminuts al llarg del camí, la qual cosa és beneficiós per a les tasques de tall. (Només per a objectes de traçat.)',
        wobble_diameter: 'Diàmetre',
        wobble_step: 'Mida de pas',
        z_step: 'Pas Z',
      },
      layer_panel: {
        current_layer: 'Capa actual',
        layer1: 'Capa 1',
        layer_bitmap: 'Mapa de bits',
        layer_cutting: 'Tall',
        layer_engraving: 'Gravat',
        layers: {
          del: 'Eliminar capa',
          dupe: 'Duplicar capa',
          fullColor: 'Tot color',
          layer: 'Capa',
          layers: 'Capes',
          lock: 'Bloquejar capa',
          merge_all: 'Fusionar tot',
          merge_down: 'Fusionar cap avall',
          merge_selected: 'Fusionar capes seleccionades',
          move_down: 'Moure capa avall',
          move_elems_to: 'Moure elements a:',
          move_selected: 'Moure elements seleccionats a una capa diferent',
          move_up: 'Moure capa amunt',
          new: 'Nova capa',
          rename: 'Reanomenar capa',
          splitFullColor: 'Expandir capa',
          switchToFullColor: 'Canviar a capa a tot color',
          switchToSingleColor: 'Canviar a capa de color únic',
          unlock: 'Desbloquejar',
        },
        move_elems_to: 'Moure elements a:',
        notification: {
          dupeLayerName: 'Ja hi ha una capa anomenada així!',
          enterNewLayerName: 'Si us plau, introdueix el nou nom de capa',
          enterUniqueLayerName: 'Si us plau, introdueix un nom de capa únic',
          layerHasThatName: 'La capa ja té aquest nom',
          mergeLaserLayerToPrintingLayerMsg: "Si us plau, tingues en compte que si completes aquesta operació, la configuració de la capa làser s'eliminarà i s'establirà segons la capa actual.",
          mergeLaserLayerToPrintingLayerTitle: "Vols fusionar aquestes capes en una capa d'Impressió?",
          mergePrintingLayerToLaserLayerMsg: "Si us plau, tingues en compte que si completes aquesta operació, la configuració de color de la capa d'impressió s'eliminarà i s'establirà segons la capa actual.",
          mergePrintingLayerToLaserLayerTitle: 'Vols fusionar aquestes capes en una capa Làser?',
          moveElemFromPrintingLayerMsg: "Si us plau, tingues en compte que si completes aquesta operació, la configuració de color de l'element seleccionat s'eliminarà i s'establirà segons %s.",
          moveElemFromPrintingLayerTitle: 'Moure element seleccionat a %s i convertir-lo en element làser?',
          moveElemToPrintingLayerMsg: "Si us plau, tingues en compte que si completes aquesta operació, la configuració de l'element seleccionat s'eliminarà i s'establirà segons %s.",
          moveElemToPrintingLayerTitle: "Moure element seleccionat a %s i convertir-lo en element d'impressió?",
          newName: 'NOU NOM',
          QmoveElemsToLayer: "Moure elements seleccionats a la capa '%s'?",
          splitColorMsg: 'Si us plau, tingues en compte que si continues amb aquesta operació, no podràs tornar a les capes de color originals.',
          splitColorTitle: 'Vols expandir la capa seleccionada en capes CMYK?',
        },
      },
      object_panel: {
        actions_panel: {
          ai_bg_removal: 'Eliminació de fons',
          ai_bg_removal_reminder: 'Prémer el botó utilitzarà immediatament 0.02 Crèdits, vols continuar?',
          ai_bg_removal_short: 'Eliminació de fons',
          array: 'Matriu',
          auto_fit: 'Ajust automàtic',
          bevel: 'Bisel',
          brightness: 'Brillantor',
          convert_to_image: 'Convertir a imatge',
          convert_to_path: 'Convertir a traçat',
          create_textpath: 'Crear text en traçat',
          create_textpath_short: 'Text en traçat',
          crop: 'Retallar',
          decompose_path: 'Descompondre',
          detach_path: 'Descompondre text en traçat',
          detach_path_short: 'Descompondre',
          disabled_by_gradient: "Si us plau, desactiva el degradat abans d'utilitzar aquesta funció.",
          disabled_by_infilled: "Si us plau, tanca el farciment abans d'utilitzar aquesta funció.",
          disabled_by_infilled_and_variable_text: "Si us plau, tanca el farciment i el text variable abans d'utilitzar aquesta funció.",
          disabled_by_variable_text: "Si us plau, tanca el text variable abans d'utilitzar aquesta funció.",
          disassemble_use: 'Desmuntar',
          disassembling: 'Desmuntant...',
          edit_path: 'Editar traçat',
          fetching_web_font: 'Obtenint la font en línia...',
          grading: 'Classificació',
          invert: 'Invertir',
          offset: 'Desplaçament',
          outline: 'Contorn',
          replace_with: 'Substituir per...',
          replace_with_short: 'Substituir',
          sharpen: 'Afilar',
          simplify: 'Simplificar',
          smart_nest: 'Nidificació intel·ligent',
          trace: 'Traçar',
          ungrouping: 'Desagrupant...',
          uploading_font_to_machine: 'Pujant font a la màquina...',
          wait_for_parsing_font: 'Analitzant font... Si us plau, espera un segon',
          weld_text: 'Soldar text',
        },
        align: 'Alinear',
        boolean: 'Booleà',
        bottom_align: 'Alinear a baix',
        center_align: 'Alinear al centre',
        difference: 'Diferència',
        distribute: 'Distribuir',
        flip: 'Girar',
        group: 'Agrupar',
        hdist: 'Distribuir horitzontalment',
        hflip: 'Gir horitzontal',
        intersect: 'Intersecar',
        left_align: "Alinear a l'esquerra",
        lock_aspect: 'Bloquejar aspecte',
        middle_align: 'Alinear al mig',
        option_panel: {
          color: 'Color',
          current_time: 'Hora actual',
          depth_engraving: 'Relleu',
          fill: 'Farciment',
          font_family: 'Font',
          font_size: 'Mida',
          font_style: 'Estil',
          layer_count: 'Recompte de capes',
          letter_spacing: 'Espaiat entre lletres',
          line_spacing: 'Espaiat entre línies',
          number: 'Número de seqüència',
          offset: 'Desplaçament',
          path_infill: 'Farciment de traçat',
          pwm_engraving: 'Mode profunditat',
          pwm_engraving_link: 'https://support.flux3dp.com/hc/en-us/articles/10419884701327',
          recently_used: 'Usat recentment',
          rounded_corner: 'Cantonada arrodonida',
          shading: 'Degradat',
          sides: 'Costats',
          start_offset: 'Desplaçament de text',
          stroke: 'Traç',
          stroke_color: 'Color de traç',
          stroke_width: 'Amplada de traç',
          text_infill: 'Farciment de text',
          threshold: 'Brillantor llindar',
          threshold_short: 'Llindar',
          variable_text: 'Text variable',
          variable_text_link: 'https://support.flux3dp.com/hc/en-us/articles/12689396604175',
          vertical_align: 'Alineació',
          vertical_text: 'Text vertical',
        },
        path_edit_panel: {
          connect: 'Connectar',
          delete: 'Eliminar',
          disconnect: 'Desconnectar',
          node_type: 'TIPUS DE NODE',
          round: 'Rodó',
          sharp: 'Angulós',
        },
        right_align: 'Alinear a la dreta',
        subtract: 'Restar',
        top_align: 'Alinear a dalt',
        ungroup: 'Desagrupar',
        union: 'Unió',
        unlock_aspect: 'Desbloquejar aspecte',
        vdist: 'Distribuir verticalment',
        vflip: 'Gir vertical',
        zoom: 'Zoom',
      },
      tabs: {
        layers: 'Capes',
        objects: 'Objectes',
        path_edit: 'Edició de traçat',
      },
      uv_print_block: {
        title: 'Impressió UV',
      },
    },
    svg_editor: {
      unable_to_fetch_clipboard_img: 'Error en obtenir imatge del portapapers',
      unnsupported_file_type: 'El tipus de fitxer no és compatible directament. Si us plau, converteix el fitxer a SVG o mapa de bits',
    },
    tag: {
      g: 'Grup',
      image: 'Imatge',
      text: 'Text',
      use: 'Importar SVG',
    },
    time_est_button: {
      calculate: 'Estimar temps',
      estimate_time: 'Temps estimat:',
    },
    tool_panels: {
      _nest: {
        end: 'Tancar',
        no_element: 'No hi ha cap element per organitzar.',
        rotations: 'Rotació possible',
        spacing: 'Espaiat',
        start_nest: 'Organitzar',
        stop_nest: 'Aturar',
      },
      _offset: {
        corner_type: 'Cantonada',
        direction: 'Direcció de desplaçament',
        dist: 'Distància de desplaçament',
        expand: 'Expandir',
        fail_message: 'Error en desplaçar objectes.',
        inward: 'Cap a dins',
        not_support_message: 'Elements seleccionats que contenen etiqueta SVG no compatible：\nImatge, Grup, Text i Objecte Importat.',
        outward: 'Cap a fora',
        round: 'Rodó',
        sharp: 'Angulós',
        shrink: 'Contraure',
      },
      array_dimension: 'Dimensió matriu',
      array_interval: 'Interval matriu',
      cancel: 'Cancel·lar',
      columns: 'Cols.',
      confirm: 'Confirmar',
      dx: 'X',
      dy: 'Y',
      grid_array: 'Crear matriu de graella',
      nest: 'Optimització de disposició',
      offset: 'Desplaçament',
      rows: 'Files',
    },
    units: {
      mm: 'mm',
      walt: 'W',
    },
    zoom_block: {
      fit_to_window: 'Ajustar a la finestra',
    },
  },
  boxgen: {
    add_option: 'Afegir opció',
    basic_box: 'Caixa bàsica',
    beam_radius: 'Compensació de tall',
    beam_radius_warning: 'Eliminar compensació de tall quan les vores o unions de la caixa són curtes per assegurar el muntatge de la caixa',
    cancel: 'Cancel·lar',
    coming_soon: 'Pròximament',
    continue_import: 'Continuar a importar',
    control_tooltip: 'Clic esquerre per rotar\nDesplaçar per fer zoom\nClic dret per moure',
    control_tooltip_touch: 'Arrossegar per rotar\nPessigar per fer zoom\nDos dits per moure',
    cover: 'Tapa',
    customize: 'Personalitzar',
    depth: 'Profunditat',
    edge: 'Vora',
    finger: 'Dit',
    finger_warning: "La longitud lateral interna de la caixa ha de ser d'almenys 6mm (0.24 polzades) per ser compatible amb la unió de dit.",
    height: 'Alçada',
    import: 'Importar',
    inner: 'Intern',
    joints: 'Unió',
    max_dimension_tooltip: "L'amplada màxima és %s, la configuració màxima d'alçada/profunditat és %s. ",
    merge: 'Fusionar',
    outer: 'Extern',
    reset: 'Restablir',
    tCount: 'Recompte T',
    tCount_tooltip: "El recompte de ranures T s'aplica al costat curt; la quantitat al costat llarg es calcula segons la seva longitud.",
    tDiameter: 'Diàmetre T',
    text_label: 'Etiqueta',
    thickness: 'Gruix',
    title: 'BOXGEN',
    tLength: 'Longitud T',
    tSlot: 'Ranura-T',
    tSlot_warning: "La longitud lateral de la caixa ha de ser d'almenys 30mm (1.18 polzades) per ser compatible amb la unió de ranura-T.",
    volume: 'Volum',
    width: 'Amplada',
    workarea: 'Àrea de treball',
    zoom: 'Zoom',
  },
  buttons: {
    back: 'Enrere',
    back_to_beam_studio: 'Tornar a Beam Studio',
    done: 'Fet',
    next: 'Següent',
  },
  calibration: {
    ador_autofocus_focusing_block: 'Prem la icona "AF" a la pàgina principal de la màquina durant 3 segons i deixa que la sonda toqui el bloc d\'enfocament.',
    ador_autofocus_material: 'Prem la icona "AF" a la pàgina principal de la màquina durant 3 segons i deixa que la sonda toqui el material suaument.',
    align_4_0: 'Dalt Esquerra',
    align_4_1: 'Dalt Dreta',
    align_4_2: 'Baix Esquerra',
    align_4_3: 'Baix Dreta',
    align_8_0: 'Exterior Dalt Esquerra',
    align_8_1: 'Exterior Dalt Dreta',
    align_8_2: 'Exterior Baix Esquerra',
    align_8_3: 'Exterior Baix Dreta',
    align_8_4: 'Interior Dalt Esquerra',
    align_8_5: 'Interior Dalt Dreta',
    align_8_6: 'Interior Baix Esquerra',
    align_8_7: 'Interior Baix Dreta',
    align_bottom_left: 'Baix Esquerra',
    align_bottom_right: 'Baix Dreta',
    align_red_cross_cut: 'Si us plau, alinea el mig de la creu vermella amb la creu tallada.',
    align_red_cross_print: 'Si us plau, alinea el mig de la creu vermella amb la creu impresa.',
    align_top_left: 'Dalt Esquerra',
    align_top_right: 'Dalt Dreta',
    analyze_result_fail: "Error al analitzar la imatge capturada.<br/>Si us plau, assegura't que:<br/>1. La imatge capturada estigui completament coberta amb paper blanc.<br/>2. La plataforma estigui enfocada correctament.",
    ask_for_skip_engraving_task: 'Vols saltar el pas de gravat i després fer foto i calibrar directament?',
    ask_for_skip_printing_task: "Vols saltar el pas d'impressió i després fer foto i calibrar directament?",
    at_focus_height: "a Alçada d'enfocament",
    at_lower_height: 'a Alçada inferior',
    back: 'Enrere',
    beamo2_autofocus_material: "Mou manualment el capçal làser per sobre del material, després baixa la sonda d'enfocament per activar l'enfocament automàtic.",
    calculating_camera_matrix: 'Calculant matriu de càmera...',
    calculating_regression_parameters: 'Calculant paràmetres de regressió...',
    calibrate_camera_before_calibrate_modules: 'Si us plau, realitza el calibratge de càmera abans de calibrar mòduls.',
    calibrate_done: "Calibratge fet. Es dóna una millor precisió de càmera quan s'enfoca amb precisió.",
    calibrate_done_diode: "Calibratge fet. S'ha guardat el desplaçament del mòdul làser de díode.",
    calibrate_success_msg: 'Calibrat amb èxit.<br/>La puntuació del calibratge és %s (%.2f).',
    calibrating: 'Calibrant...',
    calibrating_with_device_pictures: 'Calibrant amb imatges del dispositiu...',
    camera_calibration: 'Calibratge de càmera',
    camera_parameter_saved_successfully: 'Paràmetre de càmera guardat amb èxit.',
    cancel: 'Cancel·lar',
    charuco_auto_focus: "Baixa la sonda d'enfocament per enfocar automàticament al paper de tauler d'escacs.",
    charuco_capture: 'Fes clic a "Següent" per capturar.',
    charuco_place_charuco_horizontal: "Col·loca el patró de calibratge horitzontalment a <b>%s</b> de l'àrea de treball.",
    charuco_place_charuco_vertical: "Col·loca el patró de calibratge verticalment a <b>%s</b> de l'àrea de treball.",
    charuco_position_bottom_left: 'Baix Esquerra',
    charuco_position_bottom_right: 'Baix Dreta',
    charuco_position_center: 'Centre',
    charuco_position_left: 'Esquerra',
    charuco_position_right: 'Dreta',
    charuco_position_top_left: 'Dalt Esquerra',
    charuco_position_top_right: 'Dalt Dreta',
    check_checkpoint_data: 'Dades de punt de control',
    check_device_pictures: 'Comprovar imatges del dispositiu',
    check_pnp_desc: 'Assegura\'t que els marcadors vermells s\'alineïn amb els punts de gravat; si no, fes clic a "Enrere" per ajustar.',
    checking_checkpoint: 'Comprovant dades de punt de control...',
    checking_pictures: 'Comprovant imatges del dispositiu...',
    click_next: 'Fes clic a "Següent"',
    click_next_to_take_picture: 'Fes clic a Següent per fer una foto.',
    diode_calibration: 'Calibratge de mòdul làser de díode',
    do_engraving: 'Fer gravat',
    download_and_print_calibration_pattern: 'Si us plau, descarrega el fitxer de patró de calibratge a continuació i imprimeix-lo en paper A4 (o mida Letter).',
    download_calibration_pattern: 'Descarregar patró de calibratge',
    download_chessboard_file: "Descarregar fitxer de tauler d'escacs",
    downloading_checkpoint: 'Descarregant dades de punt de control...',
    downloading_pictures: 'Descarregant imatges...',
    drawing_calibration_image: 'Dibuixant imatge de calibratge...',
    dx: 'X',
    dy: 'Y',
    elevate_and_cut: 'Elevar i tallar',
    elevate_and_cut_step_1: "Col·loca una fusta de color clar de mida A4 o Letter al centre de l'espai de treball, elevada a 20mm.",
    elevate_and_cut_step_1_prism_lift: "Utilitza Ador Prism Lift a 14mm de longitud màxima amb una fusta d'almenys 6mm de gruix.",
    failed_to_calibrate_camera: '#848 Error al calibrar la càmera, si us plau contacta amb el suport de FLUX.',
    failed_to_calibrate_chessboard: "Error al calibrar amb la imatge del tauler d'escacs.",
    failed_to_calibrate_with_pictures: '#848 Error al calibrar amb imatges del dispositiu.',
    failed_to_detect_calibration_pattern: "Error al detectar el patró de calibratge. Si us plau, ajusta l'exposició de la càmera o reposiciona el patró de calibratge i torna-ho a provar.",
    failed_to_download_pictures: '#848 Error al descarregar imatges, si us plau contacta amb el suport de FLUX.',
    failed_to_move_laser_head: 'Error al moure el capçal làser.',
    failed_to_parse_checkpoint: 'Error al analitzar les dades del punt de control.',
    failed_to_save_calibration_results: '#849 Error en desar els resultats del calibratge, si us plau torna-ho a provar. Si això continua passant, si us plau contacta amb el suport de FLUX.',
    failed_to_save_camera_parameter: 'Error en desar el paràmetre de la càmera.',
    failed_to_solve_pnp: 'Error al resoldre la posició de la càmera.',
    finish: 'Fet',
    found_checkpoint: "S'han trobat dades de punt de control al teu dispositiu. Vols recuperar des del punt de control?",
    getting_plane_height: 'Obtenint alçada del pla...',
    hint_adjust_parameters: 'Utilitza aquests paràmetres per ajustar el quadrat vermell',
    hint_red_square: "Si us plau, alinea l'exterior del quadrat vermell amb el quadrat tallat.",
    material_4_a4_paper: 'Quatre fulls de paper blanc A4 (o mida Letter).',
    material_a4_calibration_pattern: 'Patró de calibratge mida A4 (o mida Letter).',
    materials_required: 'Materials necessaris:',
    module_calibration_2w_ir: 'Calibratge mòdul infraroig',
    module_calibration_printer: "Calibratge mòdul d'impressió",
    module_offset_settings: 'Configuració de desplaçament',
    module_offset_settings_desc: 'Si us plau, ajusta els valors de desplaçament X i Y per alinear la posició real de %s amb la sortida del làser CO2.',
    module_offset_settings_save_failed: 'Error en desar la configuració de desplaçament.',
    moving_laser_head: 'Movent el capçal làser...',
    moving_platform: 'Movent la plataforma...',
    next: 'Següent',
    no_picture_found: '#846 El teu dispositiu no té cap foto RAW disponible per al calibratge. Si us plau, contacta amb el suport de FLUX.',
    perform_autofocus_bb2: "Si us plau, ves al panell de control de la màquina i prem AF per realitzar l'enfocament automàtic.",
    perform_autofocus_bm2: "Mou manualment el capçal làser per sobre del material, després baixa la sonda d'enfocament per activar l'enfocament automàtic.",
    please_do_camera_calibration_and_focus: {
      beambox: "En calibrar el mòdul làser de díode, es necessita la càmera.\nSi us plau, assegura't que la càmera d'aquesta màquina ha estat calibrada.\nI amablement ajusta la plataforma al punt focal (l'alçada de l'acrílic girat)",
      beamo: "En calibrar el mòdul làser de díode, es necessita la càmera.\nSi us plau, assegura't que la càmera d'aquesta màquina ha estat calibrada.\nI amablement ajusta el capçal làser per enfocar en l'objecte de gravat (l'alçada de l'acrílic girat)",
    },
    please_goto_editor_first: 'Si us plau, completa la configuració abans de procedir',
    please_place_dark_colored_paper: "Si us plau, col·loca un paper de color fosc mida A4 o Letter al centre de l'àrea de treball.",
    please_place_paper: "Si us plau, col·loca un paper blanc mida A4 o Letter a la cantonada superior esquerra de l'àrea de treball.",
    please_place_paper_center: "Si us plau, col·loca un paper blanc mida A4 o Letter al centre de l'àrea de treball.",
    please_refocus: {
      beambox: "Amablement ajusta la plataforma al punt focal (l'alçada de l'acrílic girat)",
      beamo: "Amablement ajusta el capçal làser per enfocar en l'objecte de gravat (l'alçada de l'acrílic girat)",
      beamo_af: "Amablement prem dues vegades el botó lateral del complement d'enfocament automàtic i deixa que la sonda toqui el material suaument.",
      hexa: "Fes doble clic al botó d'ajust d'alçada per pujar la taula de niu d'abella i fer que la sonda toqui el material de gravat.",
    },
    preparing_to_take_picture: 'Preparant per fer foto...',
    promark_help_link: 'https://support.flux3dp.com/hc/en-us/articles/11173605809295',
    put_charuco_promark_2: "Si us plau, assegura't que el patró de calibratge és clarament visible sense brillantor. Fes clic a 'Següent' per fer una foto.",
    put_charuco_promark_desc_1: "Si us plau, utilitza el paper de calibratge proporcionat a la caixa d'accessoris, o imprimeix el següent fitxer en paper A4 per al calibratge de la càmera.",
    put_charuco_promark_desc_2: 'Si us plau, col·loca el paper de calibratge pla i centrat a la plataforma de treball.',
    put_chessboard: "Col·locar tauler d'escacs",
    put_chessboard_1: "Si us plau, ves al panell de control de la màquina i prem AF per realitzar l'enfocament automàtic.",
    put_chessboard_2: "Si us plau, mou el paper de tauler d'escacs o el capçal làser fins que tot el tauler d'escacs es confirmi que està dins del marc vermell a la finestra de vista prèvia en directe.",
    put_chessboard_3: "Fes clic dret per descarregar la imatge del tauler d'escacs a la ubicació actual i comprova la seva claredat.",
    put_chessboard_bb2_desc_1: "Si us plau, descarrega el següent fitxer de tauler d'escacs i imprimeix-lo en paper A4 o mida letter (el tauler d'escacs imprès ha de tenir quadrats d'1x1 cm).",
    put_chessboard_bb2_desc_2: "Assegura el paper de tauler d'escacs imprès sobre una taula no deformable, com ara acrílic o vidre, assegurant que el tauler d'escacs sigui llis i lliure d'arrugues o aixecaments.",
    put_chessboard_bb2_desc_3: "Col·loca la taula amb el tauler d'escacs plana al centre de l'àrea de treball.",
    put_chessboard_bm2_1: "Imprimeix el fitxer de tauler d'escacs en paper A4 (Mida Letter) per al calibratge.",
    put_chessboard_bm2_2: 'Fes clic a "Següent" i segueix la guia per posicinar el paper.',
    put_chessboard_promark_1: "Ajusta la distància focal a l'enfocament apropiat per a la lent de camp.",
    put_chessboard_promark_2: "Si us plau, assegura't que el paper de tauler d'escacs és clarament visible sense brillantor. Fes clic a 'Següent' per fer una foto.",
    put_chessboard_promark_desc_1: "Si us plau, utilitza el paper de tauler d'escacs proporcionat a la caixa d'accessoris, o imprimeix el següent patró de tauler d'escacs en paper A4 per al calibratge de la càmera.",
    put_chessboard_promark_desc_2: "Si us plau, col·loca el tauler d'escacs pla i centrat a la plataforma de treball",
    put_paper: 'Posar paper',
    put_paper_bm2_1: "Estén dos papers A4 blancs plans i assegura'ls.",
    put_paper_bm2_2: "Baixa la sonda d'enfocament per enfocar automàticament al paper.",
    put_paper_bm2_3: 'Tanca la coberta de la porta.',
    put_paper_bm2_4: 'Fes clic a "Començar gravat".',
    put_paper_promark_1: "Col·loca el cartró negre de la caixa d'accessoris a la plataforma de treball.",
    put_paper_promark_2: "Ajusta l'enfocament correctament, i després fes clic a ‘Començar gravat’ per procedir amb el gravat.",
    put_paper_skip: 'Si el dibuix de calibratge no procedeix automàticament a fer la foto, prem "Saltar" per fer la foto.',
    put_paper_step1: "Si us plau, col·loca un paper blanc mida A4 o Letter al centre de l'àrea de treball.",
    put_paper_step2: 'Assegura les quatre cantonades del paper per assegurar que quedi pla.',
    put_paper_step3: 'Fes clic a "COMENÇAR GRAVAT"',
    put_paper_wide_angle_1: "Col·loca quatre papers blancs A4 o mida Letter plans per cobrir tota l'àrea de treball.",
    put_paper_wide_angle_2: 'Assegura els papers per garantir que quedin plans.',
    relocate_camera: 'Relocalitzar càmera',
    relocate_camera_desc: "Si s'obre la porta o es mou el capçal làser, relocalitza la càmera i torna a alinear els punts.",
    res_average: 'Mitjà',
    res_excellent: 'Excel·lent',
    res_poor: 'Pobre',
    retake: 'Tornar a fer foto',
    rotation_angle: 'Rotació',
    show_last_config: 'Mostrar últim resultat',
    skip: 'Saltar',
    solve_pnp_bm2: "Confirma que s'han gravat 16 marques als papers. (Si no, fes clic a Enrere per gravar de nou.)",
    solve_pnp_keep_door_closed: 'Mantingues la porta tancada durant el procés.',
    solve_pnp_move_platform: 'La màquina es mourà automàticament cap avall i farà una altra foto. Si us plau, no moguis el paper de calibratge durant aquest procés.',
    solve_pnp_open_the_lid: 'Si us plau, obre la tapa per fer la foto.',
    solve_pnp_step1: 'Si us plau, alinea els punts de gravat segons el número i la posició esperada de cada punt marcador vermell.',
    solve_pnp_step2: 'Pots prémer "Tornar a fer foto" per realinear o ajustar manualment les posicions dels marcadors.',
    solve_pnp_step3: 'Si el punt de gravat està notablement desplaçat, arrossega la vista fins que el punt de gravat sigui visible, després fes clic a "Tornar a fer foto".',
    solve_pnp_title: 'Alinear punts marcadors',
    start_engrave: 'Començar gravat',
    start_printing: 'Començar impressió',
    step: 'Pas',
    taking_picture: 'Fent foto...',
    title_align_marker_points: 'Alinear punts marcadors',
    title_capture_calibration_pattern: 'Capturar patró de calibratge',
    title_confirm_calibration_result: 'Confirmar resultat de calibratge',
    title_engrave_marker_points: 'Gravar punts marcadors',
    title_prepare_materials: 'Preparar materials',
    unable_to_load_camera_parameters: "#851 No hi ha paràmetres de calibratge de càmera disponibles al teu dispositiu. Ves a 'Calibratge' > 'Calibrar càmera (Avançat)' per completar el calibratge i obtenir els paràmetres.",
    update_firmware_msg1: 'El teu firmware no admet aquesta funció. Si us plau, actualitza el firmware a v',
    update_firmware_msg2: 'o superior per continuar。 (Menú > Màquina > [La teva màquina] > Actualitzar firmware)',
    uploading_images: 'Pujant imatges...',
    use_last_config: 'Utilitzar últim valor de calibratge',
    use_old_camera_parameter: 'Vols utilitzar el paràmetre actual de lent de càmera?',
    with_af: 'Amb enfocament automàtic',
    with_prism_lift: 'Amb Ador Prism Lift',
    with_promark_safe_plus: 'Amb Promark Safe+',
    without_af: 'Sense enfocament automàtic',
    without_prism_lift: 'Sense Ador Prism Lift',
    without_promark_safe_plus: 'Sense Promark Safe+',
    x_ratio: 'Relació X',
    y_ratio: 'Relació Y',
    zendesk_link: 'https://support.flux3dp.com/hc/en-us/articles/360001811416',
  },
  camera_data_backup: {
    download_success: 'Dades de càmera descarregades amb èxit.',
    downloading_data: 'Descarregant dades...',
    estimated_time_left: 'Temps estimat restant:',
    folder_not_exists: 'La carpeta seleccionada no existeix.',
    incorrect_folder: 'Error al pujar les dades de calibratge. Si us plau, comprova si la carpeta que has seleccionat és correcta.',
    no_picture_found: "No s'ha trobat cap imatge a la màquina.",
    title: 'Còpia de seguretat de dades de càmera',
    upload_success: 'Dades de càmera pujades amb èxit.',
    uploading_data: 'Pujant dades...',
  },
  caption: {
    connectionTimeout: "Temps d'espera de connexió",
  },
  change_logs: {
    added: 'Afegit:',
    change_log: 'Registres de canvis:',
    changed: 'Canviat:',
    fixed: 'Corregit:',
    help_center_url: 'https://support.flux3dp.com/hc/en-us/sections/360000421876',
    see_older_version: 'Veure versions anteriors',
  },
  code_generator: {
    barcode: 'Codi de barres',
    qr_code: 'Codi QR',
  },
  curve_engraving: {
    '921': 'Error en enfocar automàticament.',
    '922': 'Error en realitzar mesurament de llum vermella.',
    amount: 'Quantitat',
    apply_arkwork: 'Aplicar obra sobre corba',
    apply_camera: 'Aplicar imatge de càmera sobre corba',
    click_to_select_point: 'Fes clic per seleccionar o deseleccionar punts per mesurar de nou.',
    coloumns: 'Columnes',
    column_gap: 'Espai entre columnes',
    err_object_over_range: "L'objecte supera el rang de mesurament.",
    failed_to_take_reference: 'Error al prendre referència',
    gap: 'Espai',
    help_center_url: 'https://support.flux3dp.com/hc/en-us/articles/10364060644495',
    measure_audofocus_area: "Mesurar àrea d'enfocament automàtic",
    preview_3d_curve: 'Vista prèvia gravat corbat',
    remeasure: 'Tornar a mesurar',
    remeasuring_points: 'Tornant a mesurar punts...',
    reselect_area: 'Tornar a seleccionar àrea',
    row_gap: 'Espai entre files',
    rows: 'Files',
    set_object_height: "Establir alçada de l'objecte",
    set_object_height_desc: "Mesura el gruix màxim de l'objecte.",
    start_autofocus: 'Iniciar enfocament automàtic',
    starting_measurement: 'Iniciant mesurament...',
    sure_to_delete: "Vols eliminar les dades d'enfocament de gravat corbat?",
    take_reference: 'Prendre referència',
    take_reference_desc: 'Si us plau, mou el capçal làser al punt més alt de l\'objecte, baixa la sonda d\'enfocament i fes clic a "Confirmar" per enfocar.',
  },
  device: {
    abort: 'Avortar',
    aborted: 'Avortat',
    aborting: 'Avortant',
    busy: 'Ocupat',
    cartridge_info_read_failed: "Si us plau, assegura't que la tinta estigui totalment inserida. Prova a treure la tinta i tornar-la a instal·lar.",
    cartridge_info_verification_failed: 'Si us plau, verifica que la teva tinta sigui autèntica FLUX.',
    cartridge_serial_number: 'Número de sèrie del cartutx de tinta',
    close_door_to_read_cartridge_info: 'Per accedir a la informació de tinta, si us plau tanca la coberta de la porta de la màquina.',
    completed: 'Completat',
    completing: 'Completant',
    deviceList: 'Llista de màquines',
    disable: 'Deshabilitar',
    disconnectedError: {
      caption: 'Màquina desconnectada',
      message: "Si us plau, confirma si l'accés a la xarxa de %s està disponible",
    },
    firmware_version: 'Versió de firmware',
    ink_color: 'Color de tinta',
    ink_level: 'Nivell de tinta',
    ink_type: 'Tipus de tinta',
    IP: 'IP',
    model_name: 'Nom del model',
    occupied: 'Mantenint',
    pause: 'Pausa',
    paused: 'Pausat',
    pausedFromError: 'Pausat per error',
    pausing: 'Pausant',
    please_wait: 'Si us plau, espera...',
    preparing: 'Preparant',
    processing: 'Processant',
    quit: 'Sortir',
    ready: 'Llest',
    reconnecting: 'Reconnectant',
    reset: 'Restablir (Kick)',
    resuming: 'Reprenent',
    retry: 'Reintentar',
    running: 'Treballant',
    scanning: 'Escanejant',
    select: 'Seleccionar',
    select_printer: 'Seleccionar impressora',
    serial_number: 'Número de sèrie',
    start: 'Inici',
    starting: 'Iniciant',
    status: 'Estat',
    submodule_type: 'Mòdul',
    toolhead_change: "Canviar capçal d'eina",
    unknown: 'Desconegut',
    uploading: 'Pujant',
    UUID: 'UUID',
  },
  device_selection: {
    go_to_settings: 'Ves a Configuració',
    macos_15_local_network_permission: "A macOS 15 o posterior, si us plau habilita l'accés de Beam Studio a la xarxa local a Configuració del sistema > Privadesa i seguretat > Xarxa local.",
    no_device: '#801 No podem trobar la teva màquina a la xarxa.\nAmablement segueix la <a target="_blank" href="https://support.flux3dp.com/hc/en-us/articles/360001683556">guia</a> per solucionar el problema de connexió.',
    no_device_web: "#801 Si us plau, comprova l'estat de la teva màquina, o fes clic a ‘Configuració de màquina’ a continuació per configurar la màquina.",
    select_usb_device: 'Selecciona dispositiu USB',
  },
  editor: {
    exposure: 'Brillantor',
    nozzle_refresh_area: 'Àrea de refresc del broquet',
    opacity: 'Opacitat de vista prèvia',
    prespray_area: "Àrea d'encebament",
  },
  error_pages: {
    screen_size: "Si us plau, tingues en compte que Beam Studio pot no funcionar de manera òptima al teu dispositiu. Per a una experiència òptima, hauria de ser un dispositiu amb una amplada de pantalla d'almenys 1024 píxels.",
  },
  flux_id_login: {
    connection_fail: '#847 Error en connectar al servei de membres FLUX.',
    email: 'Correu electrònic',
    flux_plus: {
      access_monotype_feature: 'No tens el complement de fonts Monotype.',
      access_monotype_feature_note: 'Has de tenir la subscripció FLUX+ Pro o el complement de fonts Monotype per accedir a aquesta funció.',
      access_plus_feature_1: 'Estàs accedint a una funció',
      access_plus_feature_2: '.',
      access_plus_feature_note: 'Has de tenir la subscripció FLUX+ per accedir a aquesta funció.',
      ai_credit_tooltip: 'Per a funcions IA',
      explore_plans: 'Explorar plans FLUX+',
      features: {
        ai_bg_removal: 'Eliminació de fons IA',
        boxgen: 'Generador de caixes 3D',
        dmkt: '1000+ fitxers de disseny',
        monotype: '250+ fonts premium',
        my_cloud: 'Emmagatzematge al núvol il·limitat',
      },
      flux_credit_tooltip: 'Per a fitxers de Design Market i eliminació de fons IA',
      get_addon: 'Obtenir complement',
      goto_member_center: 'Ves al Centre de membres',
      learn_more: 'Saber-ne més',
      member_center_url: 'https://member.flux3dp.com/en-US/subscription',
      subscribe_now: 'Subscriu-te ara',
      thank_you: 'Gràcies per ser un membre valorat!',
      website_url: 'https://flux3dp.com/subscription',
    },
    forget_password: 'Has oblidat la contrasenya?',
    incorrect: "L'adreça de correu electrònic o la contrasenya no són correctes.",
    login: 'Inicia sessió',
    login_success: 'Sessió iniciada',
    lost_password_url: 'https://id.flux3dp.com/user/forgot-password',
    new_to_flux: 'Nou a FLUX? Crea un compte.',
    not_verified: "L'adreça de correu electrònic encara no ha estat verificada.",
    password: 'Contrasenya',
    register: 'Crea el teu compte FLUX',
    remember_me: "Recorda'm",
    sign_in_later: 'Inicia sessió més tard',
    signup_url: 'https://id.flux3dp.com/user/login#up',
    unlock_shape_library: 'Inicia sessió per desbloquejar la base de dades de formes.',
  },
  framing: {
    area_check: "Comprovació d'àrea",
    areacheck_desc: "Assegura que l'àrea de treball és segura previsualitzant el quadre delimitador de l'objecte i la zona d'acceleració del capçal làser.",
    calculating_task: 'Calculant tasca...',
    continuously: 'Contínuament',
    contour: 'Contorn',
    contour_desc: 'Previsualitza el contorn real del patró.',
    framing: 'Emmarcat',
    framing_desc: "Previsualitza el quadre delimitador de l'objecte.",
    hull: 'Casc',
    hull_desc: "Previsualitza una forma que segueix de prop el disseny, com una banda elàstica embolicada al voltant de l'objecte.",
    low_laser: 'Làser baix',
    low_laser_desc: "Estableix un valor làser de baixa potència per a la tasca d'emmarcat.",
    rotate_axis: 'Rotar eix',
    rotateaxis_desc: "Previsualitza el centre de l'eix de rotació, l'eix en si no es mou.",
    rotation_frame_warning: 'La vista prèvia del marc rotarà una vegada. Evita aturar-te a mig camí per prevenir desalineació de la posició de marcatge.',
    rotation_framing_desc: "Previsualitza el rang complet de rotació, l'eix rota segons la vista prèvia.",
    start_task: 'Iniciar tasca',
    start_task_description: 'Després de completar la vista prèvia del marc, fes clic a "Iniciar tasca" per enviar el treball.',
  },
  general: {
    choose_folder: 'Tria carpeta',
    processing: 'Processant...',
  },
  generators: {
    box_generator: 'Generador de caixes',
    code_generator: 'Generador de codis',
    material_test_generator: 'Generador de prova de material',
    title: 'Generadors',
  },
  generic_error: {
    OPERATION_ERROR: "[OE] S'ha produït un conflicte d'estat, si us plau torna a intentar l'acció.",
    SUBSYSTEM_ERROR: '[SE] Error quan el firmware de la màquina executa la tasca. Si us plau, reinicia la màquina.',
    UNKNOWN_COMMAND: '[UC] Si us plau, actualitza el firmware del dispositiu',
    UNKNOWN_ERROR: "[UE] S'ha produït un error desconegut. Si us plau, reinicia Beam Studio i la màquina.",
  },
  global: {
    apply: 'Aplicar',
    back: 'Enrere',
    cancel: 'Cancel·lar',
    editing: {
      redo: 'Refer',
      reset: 'Restablir',
      reset_view: 'Restablir vista',
      undo: 'Desfer',
      zoom_in: 'Apropar',
      zoom_out: 'Allunyar',
    },
    enable: 'Habilitar',
    mode_conflict: 'Aquesta opció no està disponible en el mode actual.',
    ok: "D'acord",
    preview: 'Vista prèvia',
    save: 'Desar',
    save_and_exit: 'Desar i sortir',
    saving: 'Guardant...',
    select: 'Seleccionar',
    stop: 'Aturar',
  },
  google_font_panel: {
    all_languages: 'Tots els idiomes',
    category: 'Categoria',
    language_label: 'Idioma',
    language_placeholder: 'Idioma',
    language_unavailable_offline: 'No disponible fora de línia',
    more_google_fonts: 'Més fonts de Google...',
    no_fonts_available: 'No hi ha fonts disponibles.',
    no_internet_connection: 'Sense connexió a internet',
    no_results_message: "No s'han trobat fonts que coincideixin amb els teus criteris de cerca.",
    no_selection: 'Cap font seleccionada',
    offline_message: "Les fonts de Google no estan disponibles fora de línia. Si us plau, connecta't a internet per explorar i seleccionar fonts de Google.",
    search_placeholder: 'Cercar fonts...',
    search_unavailable_offline: 'Cerca no disponible fora de línia',
    selected_prefix: 'Seleccionat:',
    title: 'Fonts de Google',
    unavailable_message: 'Les fonts de Google no estan disponibles actualment. Si us plau, comprova la teva connexió a internet o contacta amb el teu administrador.',
  },
  image_edit_panel: {
    eraser: {
      brush_size: 'Mida del pinzell',
      description: 'Fes clic o arrossega per esborrar manualment àrees no desitjades.',
      title: "Goma d'esborrar",
    },
    magic_wand: {
      description: 'Selecciona i elimina àrees adjacents basades en la similitud de color.',
      title: 'Vareta màgica',
      tolerance: 'Tolerància',
    },
    rounded_corner: {
      description: "Ajusta la rodonesa de les cantonades de l'objecte.",
      radius: 'Radi',
      title: 'Cantonada arrodonida',
    },
    title: 'Editar imatge',
  },
  initialize: {
    back: 'Enrere',
    cancel: 'Cancel·lar',
    confirm: 'Confirmar',
    connect: 'Connectar',
    connect_ethernet: {
      title: 'Connexió directa',
      tutorial1: '1. Connecta la màquina amb el teu ordinador amb cable ethernet.',
      tutorial2_1: '2. Segueix ',
      tutorial2_2: ' per fer que el teu ordinador actuï com a router.',
      tutorial2_a_href_mac: 'https://support.flux3dp.com/hc/en-us/articles/360001517076',
      tutorial2_a_href_win: 'https://support.flux3dp.com/hc/en-us/articles/360001507715',
      tutorial2_a_text: 'aquesta guia',
      tutorial3: '3. Fes clic a Següent.',
    },
    connect_machine_ip: {
      alert: {
        swiftray_connection_error: `No es pot connectar al servidor. Si us plau, reinicia Beam Studio i torna-ho a provar.`,
      },
      check_camera: 'Comprovant disponibilitat de càmera',
      check_connection: 'Comprovant connexió de màquina',
      check_firmware: 'Comprovant versió de firmware',
      check_ip: "Comprovant disponibilitat d'IP",
      check_swiftray_connection: 'Comprovant connexió al servidor',
      check_swiftray_connection_unreachable: 'servidor inaccessible',
      check_usb: 'Comprovar connexió USB',
      connection_failed_hint: 'No es pot connectar a la màquina. Si us plau, consulta <a target="_blank" href="https://support.flux3dp.com/hc/en-us/articles/360001683556">aquesta guia</a> per solucionar el problema.',
      enter_ip: "Introdueix l'IP de la teva màquina",
      finish_setting: 'Comença a crear!',
      invalid_format: 'Format no vàlid',
      invalid_ip: 'IP no vàlida: ',
      promark_hint: 'Si falles repetidament en connectar via USB, si us plau consulta l\'<a target="_blank" href="https://support.flux3dp.com/hc/en-us/articles/11318820440591">article del Centre d\'Ajuda</a>.',
      retry: 'Reintentar',
      starts_with_169254: 'Comença amb 169.254',
      succeeded_message: 'Connectat amb èxit 🎉',
      unreachable: 'IP inaccessible',
      unreachable_macos_15: 'A macOS 15 o posterior, si us plau habilita l\'accés de Beam Studio a la xarxa local a Configuració del sistema > <a target="_blank" href="x-apple.systempreferences:com.apple.preference.security?Privacy_LocalNetwork">Privadesa i seguretat</a> > Xarxa local.',
    },
    connect_usb: {
      connect_camera: 'Connecta la càmera de la màquina al teu ordinador amb cable USB.',
      title: 'Connexió USB',
      title_sub: ' (Només HEXA i Ador)',
      turn_off_machine: 'Apaga la màquina.',
      turn_on_machine: 'Encén la màquina.',
      tutorial1: 'Connecta la màquina al teu ordinador amb cable USB.',
      tutorial2: "Fes clic a 'Següent'.",
      wait_for_turning_on: "Fes clic a 'Següent' després que el procés d'inici s'hagi completat i hagis entrat a la pantalla principal.",
    },
    connect_wifi: {
      title: 'Connectant a Wi-Fi',
      tutorial1: '1. Ves al Panell tàctil > Fes clic a "Xarxa" > "Connectar a WiFi".',
      tutorial1_ador: '1. Ves al Panell tàctil > Fes clic a "MÀQUINA" > Fes clic a "Xarxa" > "Connectar a WiFi".',
      tutorial2: '2. Selecciona i connecta el teu Wi-Fi preferit.',
      what_if_1: 'Què passa si no veig el meu Wi-Fi?',
      what_if_1_content: "1. El mode de xifratge Wi-Fi hauria de ser WPA2 o sense contrasenya.\n2. El mode de xifratge es pot establir a la interfície d'administració del router Wi-Fi. Si el router no admet WPA2 i necessites ajuda per triar el router adequat, si us plau contacta amb el suport de FLUX.",
      what_if_2: 'Què passa si no veig cap Wi-Fi?',
      what_if_2_content: "1. Assegura't que l'adaptador Wi-Fi estigui totalment endollat.\n2. Si no hi ha adreça MAC de la xarxa sense fils a la pantalla tàctil, si us plau contacta amb el suport de FLUX.\n3. El canal Wi-Fi hauria de ser 2.4Ghz (5Ghz no és compatible).",
    },
    connect_wired: {
      title: 'Connectant a xarxa per cable',
      tutorial1: '1. Connecta la màquina amb el teu router.',
      tutorial2: '2. Prem "Xarxa" per obtenir l\'IP de la xarxa per cable.',
      tutorial2_ador: '2. Prem "MÀQUINA" > "Xarxa" per obtenir l\'IP de la xarxa per cable.',
      what_if_1: "Què passa si l'IP està buida?",
      what_if_1_content: "1. Assegura't que el cable Ethernet estigui totalment endollat.\n2. Si no hi ha adreça MAC de la xarxa per cable a la pantalla tàctil, si us plau contacta amb el suport de FLUX.",
      what_if_2: "Què passa si l'IP comença amb 169?",
      what_if_2_content: "1. Si l'adreça IP comença amb 169.254, hauria de ser un problema de configuració DHCP, si us plau contacta amb el teu ISP (proveïdor de serveis d'internet) per a més assistència.\n2. Si el teu ordinador es connecta a internet directament utilitzant PPPoE, si us plau canvia a utilitzar el router per connectar utilitzant PPPoE, i habilita la funció DHCP al router.",
    },
    connecting: 'Connectant...',
    connection_types: {
      ether2ether: 'Connexió directa',
      usb: 'Connexió USB',
      wifi: 'Wi-Fi',
      wired: 'Xarxa per cable',
    },
    next: 'Següent',
    no_machine: 'No tinc una màquina ara.',
    promark: {
      configuration_confirmation: 'Això assegura que el teu Promark estigui configurat correctament per a una eficiència i precisió òptimes.',
      or_complete_later: `O, salta aquest pas i completa la Configuració de Promark més tard a:
Màquines > ‘Nom Promark’ > Configuració de Promark`,
      qc_instructions: 'Omple els paràmetres situats a la part posterior de la targeta ‘QC Pass’',
      select_laser_source: 'Selecciona el teu Promark',
      select_workarea: 'Selecciona àrea de treball',
      settings: 'Configuració de Promark',
    },
    retry: 'Reintentar',
    select_beambox: 'Selecciona el teu Beambox',
    select_beamo: 'Selecciona el teu beamo',
    select_connection_type: 'Com vols connectar-te?',
    select_hexa: 'Selecciona el teu HEXA',
    select_language: 'Selecciona idioma',
    select_machine_type: 'Selecciona el teu tipus de màquina',
    setting_completed: {
      back: 'Enrere',
      great: 'Benvingut a Beam Studio',
      ok: 'COMENÇAR A CREAR',
      setup_later: 'Sempre pots configurar la teva màquina des de la barra de títol > "Màquines" > "Configuració de màquina"',
      start: 'Inici',
    },
    skip: 'Saltar',
    start: 'Inici',
  },
  input_machine_password: {
    connect: 'CONNECTAR',
    password: 'Contrasenya',
    require_password: '"%s" requereix una contrasenya',
  },
  insecure_websocket: {
    extension_detected: 'Extensió Beam Studio Connect detectada',
    extension_detected_description: "Hem detectat que has instal·lat l'extensió Beam Studio Connect. Si us plau, fes clic a ‘Confirmar’ per redirigir a HTTPS, o fes clic a ‘Cancel·lar’ per continuar utilitzant HTTP.",
    extension_not_deteced: "No es pot detectar l'extensió Beam Studio Connect",
    extension_not_deteced_description: "Per utilitzar HTTPS, si us plau fes clic a ‘Confirmar’ per instal·lar l'extensió Beam Studio Connect. Després d'instal·lar l'extensió, si us plau refresca la pàgina per activar-la.<br/>En cas contrari, fes clic a l'enllaç a continuació per veure com utilitzar HTTP a Chrome.",
    unsecure_url_help_center_link: '<a target="_blank" href="https://support.flux3dp.com/hc/en-us/articles/9935859456271">Enllaç</a>',
  },
  layer_module: {
    general_laser: 'Làser',
    laser_2w_infrared: 'Làser infraroig 2W',
    laser_10w_diode: 'Làser de díode 10W',
    laser_20w_diode: 'Làser de díode 20W',
    non_working_area: 'Àrea sense treball',
    none: 'Cap',
    notification: {
      convertFromLaserModuleMsg: "Si us plau, tingues en compte que si completes aquesta operació, la configuració de la capa làser s'eliminarà i s'establirà segons la capa actual.",
      convertFromLaserModuleTitle: "Vols convertir el mòdul Làser en mòdul d'Impressió?",
      convertFromPrintingModuleMsg: "Si us plau, tingues en compte que si completes aquesta operació, la configuració de color de la capa d'impressió s'eliminarà i s'establirà segons la capa actual.",
      convertFromPrintingModuleTitle: "Vols convertir el mòdul d'Impressió en mòdul Làser?",
      importedDocumentContainsPrinting: "El document conté capa d'impressió, t'agradaria canviar l'àrea de treball a Ador?",
      importedDocumentContainsPrinting4C: "El document conté capa d'impressió, t'agradaria canviar l'àrea de treball a beamo II?",
      performIRCaliMsg: 'Fes clic a “Confirmar” per executar el calibratge, o accedeix al calibratge a través del menú superior.<br />(Màquina > [Nom de la teva màquina] >  Calibrar mòdul infraroig)',
      performIRCaliTitle: 'Realitzar el calibratge del mòdul infraroig',
      performPrintingCaliMsg: "Fes clic a “Confirmar” per executar el calibratge, o accedeix al calibratge a través del menú superior.<br />(Màquina > [Nom de la teva màquina] >  Calibrar mòdul d'impressió)",
      performPrintingCaliTitle: "Realitzar el calibratge del mòdul d'impressió",
      printingLayersConverted: "Les capes d'impressió s'han convertit en capes làser.",
    },
    printing: 'Impressió',
    unknown: 'Mòdul desconegut',
    uv_print: 'Impressió UV',
    uv_varnish: 'Vernís',
    uv_white_ink: 'Tinta blanca',
  },
  machine_status: {
    '-17': 'Mode IO cartutx',
    '-10': 'Mode manteniment',
    '-2': 'Escanejant',
    '-1': 'Mantenint',
    0: 'Inactiu',
    1: 'Iniciant',
    2: 'ST_TRANSFORM',
    4: 'Iniciant',
    6: 'Reprenent',
    16: 'Treballant',
    18: 'Reprenent',
    32: 'Pausat',
    36: 'Pausat',
    38: 'Pausant',
    48: 'Pausat',
    50: 'Pausant',
    64: 'Completat',
    66: 'Completant',
    68: 'Preparant',
    128: 'Avortat',
    256: 'Alarma',
    512: 'Fatal',
    UNKNOWN: 'Desconegut',
  },
  material_test_generator: {
    block_settings: 'Configuració de bloc',
    columns: 'Columnes',
    count: 'Recompte',
    cut: 'Tallar',
    engrave: 'Gravar',
    export: 'Exportar',
    max: 'Màx',
    min: 'Mín',
    parameter: 'Paràmetre',
    rows: 'Files',
    size: 'Mida (AxL)',
    spacing: 'Espaiat',
    table_settings: 'Configuració de taula',
    text_settings: 'Configuració de text',
    title: 'Generador de prova de material',
  },
  menu: {
    inches: 'Polzades',
    mm: 'mm',
  },
  message: {
    auth_error: "#820 Error d'autenticació: Si us plau, actualitza Beam Studio i el firmware de la màquina a l'última versió.",
    authenticating: 'Autenticant...',
    auto_focus: {
      instruction: "Si us plau, mou el capçal del mòdul làser per sobre de l'objecte, i segueix les instruccions de l'animació per prémer AF per enfocar.",
      succeeded: 'Enfocat amb èxit',
      title: 'Enfocament automàtic',
      warning_at_coordinates: "Després d'entrar al mode d'enfocament automàtic, el capçal làser es restablirà i es mourà a la posició especificada per enfocar. \nSi us plau, assegura't que la posició objectiu estigui sobre el material i que no hi hagi obstacles en el camí de moviment.",
    },
    backend_calculation: {
      analyzing_svg: 'Analitzant SVG - %d%% ...',
      calculating_task_path: 'Calculant camí de tasca - %d%% ...',
      finishing: 'Finalitzant...',
      initializing: 'Inicialitzant...',
    },
    camera: {
      abort_preview: 'Avortar',
      calibration_wide_angle_camera_first: 'Si us plau, calibra primer la càmera gran angular.',
      camera_cable_unstable: "Es detecta que la càmera està transferint fotos de manera inestable. La vista prèvia encara es pot realitzar normalment, però hi pot haver el problema de vista prèvia lenta o temps d'espera.",
      continue_preview: 'Continuar',
      door_opened: 'Porta oberta',
      door_opened_text: 'Si us plau, tanca la porta abans de reiniciar la vista prèvia de la càmera.',
      fail_to_transmit_image: '#845 Alguna cosa ha anat malament amb la transmissió d\'imatge. Si us plau, reinicia la teva màquina o Beam Studio. Si aquest error persisteix, si us plau segueix <a target="_blank" href="https://flux3dp.zendesk.com/hc/en-us/articles/4402756056079">aquesta guia</a>.',
      switching_camera: 'Canviant la càmera...',
      ws_closed_unexpectedly: '#844 La connexió a la càmera de la màquina s\'ha tancat inesperadament. Si aquest error persisteix, si us plau segueix <a target="_blank" href="https://support.flux3dp.com/hc/en-us/articles/4402755805071">aquesta guia</a>.',
    },
    cancelling: 'Cancel·lant...',
    cant_connect_to_device: '#827 No es pot connectar la màquina, si us plau comprova la teva connexió',
    connected: 'Connectat',
    connecting: 'Connectant...',
    connectingCamera: 'Connectant càmera...',
    connectingMachine: 'Connectant %s...',
    connectionTimeout: "#805 Temps d'espera de connexió del dispositiu. Si us plau, comprova l'estat de la teva xarxa i l'indicador Wi-Fi de la teva màquina.",
    device_blocked: {
      caption: 'Número de sèrie no autoritzat',
      offline: "El número de sèrie del teu dispositiu està restringit a l'ús fora de línia ja que sembla estar desactivat. Si us plau, proporciona el número de sèrie de la màquina (situat a la part posterior del dispositiu) al teu minorista i fes que contactin amb support@flux3dp.com per activar l'autorització en línia. Si vols utilitzar el dispositiu fora de línia, si us plau contacta amb support@flux3dp.com directament.",
      online: "El número de sèrie del teu dispositiu sembla estar desactivat. Si us plau, proporciona el número de sèrie de la màquina (situat a la part posterior del dispositiu) al teu minorista i fes que contactin amb support@flux3dp.com per activar l'autorització del dispositiu.",
    },
    device_busy: {
      caption: 'Màquina ocupada',
      message: 'La màquina està executant una altra tasca, torna-ho a provar més tard. Si deixa de funcionar, si us plau reinicia la màquina.',
    },
    device_is_used: "La màquina s'està utilitzant, vols avortar la tasca actual?",
    device_not_found: {
      caption: 'Màquina per defecte no trobada',
      message: "#812 Si us plau, comprova l'indicador Wi-Fi de la teva màquina",
    },
    disconnected: 'Connexió inestable, si us plau comprova la connexió del dispositiu i torna-ho a provar més tard',
    endingLineCheckMode: 'Sortint del mode de comprovació de línia...',
    endingRawMode: 'Sortint del mode de control de màquina...',
    enteringLineCheckMode: 'Entrant al mode de comprovació de línia...',
    enteringRawMode: 'Entrant al mode de control de màquina...',
    enteringRedLaserMeasureMode: 'Entrant al mode de mesura làser vermell...',
    exitingRotaryMode: 'Sortint del mode rotatori...',
    getProbePosition: 'Obtenint posició de la sonda...',
    gettingLaserSpeed: 'Llegint velocitat del capçal làser...',
    homing: 'Anant a casa...',
    mac_os_arch_mismatch: {
      caption: 'Reinstal·lar versió compatible',
      download_center: 'Centre de descàrregues',
      message: 'Aquest Mac utilitza Apple silicon. Descarrega la versió Apple silicon i reinstal·la.',
    },
    need_password: 'Necessita contrasenya per connectar a la màquina',
    please_enter_dpi: 'Si us plau, introdueix la unitat del teu fitxer (en mm)',
    preview: {
      adjust: 'Ajustar',
      adjust_height_tooltip: "Fes clic a la casella de selecció per habilitar l'edició.",
      already_performed_auto_focus: "Ja has realitzat l'enfocament automàtic, utilitzar valors existents?",
      camera_preview: 'Vista prèvia de càmera',
      capturing_image: 'Capturant imatge...',
      enter_manually: 'Introduir manualment',
      getting_focal_distance: 'Obtenint distància focal...',
      moving_to_preview_position: 'Movent a posició de vista prèvia...',
      please_enter_height: "Si us plau, introdueix l'alçada de l'objecte. Per capturar una foto de càmera precisa.",
      please_focus_before_preview: "Per obtenir una millor qualitat de vista prèvia, si us plau, realitza l'enfocament automàtic abans de previsualitzar.",
      press_esc_to_stop: 'Prem ESC per aturar la vista prèvia de la càmera.',
      succeeded: 'Vista prèvia reeixida',
    },
    promark_disconnected: "#850 Connexió del dispositiu interrompuda, si us plau comprova l'estat de connexió del dispositiu.",
    redLaserTakingReference: 'Prenent referència...',
    retrievingCameraOffset: 'Llegint desplaçament de càmera...',
    settingLaserSpeed: 'Establint velocitat del capçal làser...',
    swiftray_disconnected: 'No es pot connectar al backend, intentant reconnectar.',
    swiftray_reconnected: 'Backend reconnectat, si us plau prova de reenviar el treball.',
    time_remaining: 'Temps restant:',
    tryingToConenctMachine: 'Intentant connectar a la màquina...',
    turningOffAirPump: "Apagant bomba d'aire...",
    turningOffFan: 'Apagant ventilador...',
    unable_to_find_machine: 'No es pot trobar la màquina ',
    unable_to_start: "#830 No es pot iniciar la tasca. Si us plau, torna-ho a provar. Si això passa de nou, si us plau contacta amb nosaltres amb informe d'errors:\n",
    unavailableWorkarea: "#804 L'àrea de treball actual supera l'àrea de treball d'aquesta màquina. Si us plau, comprova l'àrea de treball de la màquina seleccionada o estableix l'àrea de treball des d'Edita > Configuració del document.",
    unknown_device: "#826 No es pot connectar a la màquina, si us plau assegura't que l'USB estigui connectat a la màquina",
    unknown_error: "#821 L'aplicació ha trobat un error desconegut, si us plau utilitza Ajuda > Menú > Informe d'errors.",
    unsupport_osx_version: 'La versió actual de macOS %s pot no admetre algunes funcions. Si us plau, actualitza a macOS 13+.',
    unsupport_win_version: "La versió actual del sistema operatiu %s pot no admetre algunes funcions. Si us plau, actualitza a l'última versió.",
    unsupported_example_file: "El fitxer d'exemple seleccionat no és compatible amb l'àrea de treball actual.",
    uploading_fcode: 'Pujant FCode',
    usb_unplugged: 'Connexió USB perduda. Si us plau, comprova la teva connexió USB',
    wrong_swiftray_version_message: 'Versió de backend incorrecta (versió: {version}). Si us plau, comprova si hi ha múltiples instàncies de Beam Studio executant-se i tanca qualsevol instància addicional abans de reintentar.',
    wrong_swiftray_version_title: 'Versió de backend incorrecta',
  },
  monitor: {
    ask_reconnect: "La connexió amb la màquina s'ha trencat. Vols reconnectar?",
    bug_report: "Informe d'errors",
    camera: 'Càmera',
    cancel: 'Cancel·lar',
    confirmFileDelete: 'Estàs segur que vols eliminar aquest fitxer?',
    connecting: 'Connectant, si us plau espera...',
    DEVICE_ERROR: 'Alguna cosa ha anat malament\nSi us plau, reinicia la màquina',
    download: 'Descarregar',
    extensionNotSupported: 'Aquest format de fitxer no és compatible',
    fileExistContinue: 'El fitxer ja existeix, vols substituir-lo?',
    forceStop: 'Vols avortar la tasca actual?',
    go: 'Inici',
    HARDWARE_ERROR_AIR_ASSIST_ABNORMAL: "#913 Sensor de flux d'aire anòmal",
    HARDWARE_ERROR_BOTTOM_OPENED: '#903 Fons obert. Tanca el fons per continuar.',
    HARDWARE_ERROR_COVER_NOT_CLOSED: "#924 Error al instal·lar coberta del capçal d'impressió",
    HARDWARE_ERROR_COVER_NOT_OPENED: "#925 Error al treure coberta del capçal d'impressió",
    HARDWARE_ERROR_DOOR_OPENED: '#901 Tanca la porta per continuar.',
    HARDWARE_ERROR_DRAWER_OPENED: '#911 Calaix obert',
    HARDWARE_ERROR_FIRE_DETECTED: '#912 Sensor de flama anòmal',
    HARDWARE_ERROR_HEADTYPE_MISMATCH: '#915 Mòdul incorrecte detectat. Si us plau, instal·la el mòdul correcte per continuar.',
    HARDWARE_ERROR_HEADTYPE_NONE: "#917 Mòdul no detectat. Si us plau, assegura't que el mòdul estigui instal·lat correctament per continuar.",
    HARDWARE_ERROR_HEADTYPE_UNKNOWN: '#918 Mòdul desconegut detectat. Si us plau, instal·la el mòdul correcte per continuar.',
    HARDWARE_ERROR_HOMING_PULLOFF_FAILED: "#920 Error de retirada d'inici",
    HARDWARE_ERROR_MAINBOARD_ERROR: '#401 Error crític: Placa base fora de línia. Si us plau, contacta amb el suport de FLUX.',
    HARDWARE_ERROR_OVER_TEMPERATURE: '#902 Sobreescalfament. Si us plau, espera uns minuts.',
    HARDWARE_ERROR_PLATFORM_HOMING_FAILED: '#910 Restabliment eix Z fallit',
    HARDWARE_ERROR_PRINTER_NO_RESPONSE: "#919 Mòdul d'impressió sense resposta.",
    HARDWARE_ERROR_PROBE_SHOWED: 'Si us plau, retreu la sonda.',
    HARDWARE_ERROR_PUMP_ERROR: "#900 Si us plau, comprova el teu tanc d'aigua.",
    HARDWARE_ERROR_ROTARY_NOT_DETECTED: '#914 Cap mòdul rotatori detectat',
    HARDWARE_ERROR_SUBSYSTEM_ERROR: '#402 Error crític: Subsistema sense resposta. Si us plau, contacta amb el suport de FLUX.',
    HARDWARE_FAILURE: 'Alguna cosa ha anat malament\nSi us plau, reinicia la màquina',
    hour: 'h',
    left: 'restant',
    MAINBOARD_OFFLINE: '#905 Error en connectar a la placa base.\nSi us plau, reinicia la màquina. ',
    minute: 'm',
    monitor: 'MONITOR',
    NO_RESPONSE: '#905 Error en connectar a la placa base.\nSi us plau, reinicia la màquina.',
    no_task_info: 'Actualment no hi ha tasques per mostrar.',
    pause: 'Pausa',
    prepareRelocate: 'Preparant per relocalitzar',
    processing: 'Processant',
    record: 'Registre',
    relocate: 'Relocalitzar',
    RESOURCE_BUSY: 'La màquina està ocupada\nSi no està funcionant, si us plau reinicia la màquina',
    resume: 'Reprendre',
    savingPreview: 'Generant miniatures',
    second: 's',
    start: 'Inici',
    stop: 'Aturar',
    SUBSYSTEM_ERROR: '#402 Error crític: Subsistema sense resposta. Si us plau, contacta amb el suport de FLUX.',
    task: {
      BEAMBOX: 'Gravat làser',
      'N/A': 'Mode lliure',
    },
    taskTab: 'Tasca',
    temperature: 'Temperatura',
    upload: 'Pujar',
    USER_OPERATION: 'Si us plau, segueix les instruccions al panell del dispositiu per continuar.',
    USER_OPERATION_CHANGE_CARTRIDGE: 'Si us plau, insereix el cartutx correcte per continuar.',
    USER_OPERATION_CHANGE_CARTRIDGE_CARTRIDGE_NOT_DETECTED: 'Si us plau, insereix el cartutx per continuar.',
    USER_OPERATION_CHANGE_TOOLHEAD: 'Si us plau, instal·la el mòdul correcte per continuar.',
    USER_OPERATION_CHANGE_TOOLHEAD_HEADTYPE_MISMATCH: '#915 Mòdul incorrecte detectat. Si us plau, instal·la el mòdul correcte per continuar.',
    USER_OPERATION_CHANGE_TOOLHEAD_HEADTYPE_NONE: "#917 Mòdul no detectat. Si us plau, assegura't que el mòdul estigui instal·lat correctament per continuar.",
    USER_OPERATION_CHANGE_TOOLHEAD_HEADTYPE_UNKNOWN: '#918 Mòdul desconegut detectat. Si us plau, instal·la el mòdul correcte per continuar.',
    USER_OPERATION_REMOVE_CARTRIDGE: 'Si us plau, treu el cartutx per continuar.',
    USER_OPERATION_ROTARY_PAUSE: 'Si us plau, canvia al motor rotatori.',
  },
  my_cloud: {
    action: {
      confirmFileDelete: 'Estàs segur que vols eliminar aquest fitxer? Aquesta acció no es pot desfer.',
      delete: 'Eliminar',
      download: 'Descarregar',
      duplicate: 'Duplicar',
      open: 'Obrir',
      rename: 'Reanomenar',
    },
    file_limit: 'Fitxer gratuït',
    loading_file: 'Carregant...',
    no_file_subtitle: 'Ves a Menú > "Fitxer" > "Desar al núvol"',
    no_file_title: 'Desa fitxers al Meu núvol per començar.',
    not_login_title: 'Inicia sessió per emmagatzemar els teus fitxers al Núvol.',
    save_file: {
      choose_action: 'Desar fitxer:',
      input_file_name: 'Introdueix nom del fitxer:',
      invalid_char: 'Caràcters no vàlids:',
      save: 'Desar',
      save_new: 'Desar com a fitxer nou',
      storage_limit_exceeded: 'El teu emmagatzematge al núvol ha arribat al límit superior. Si us plau, elimina qualsevol fitxer innecessari abans de desar-ne de nous.',
    },
    sort: {
      a_to_z: 'Nom: A - Z',
      most_recent: 'Més recent',
      oldest: 'Més antic',
      z_to_a: 'Nom: Z - A',
    },
    title: 'El meu núvol',
    upgrade: 'Actualitzar',
  },
  noun_project_panel: {
    clear: 'Esborrar',
    elements: 'Elements',
    enjoy_shape_library: 'Gaudeix de la base de dades de formes.',
    export_svg_title: 'No es pot exportar SVG',
    export_svg_warning: "Aquest projecte conté objectes que estan protegits per la llei de propietat intel·lectual. Per tant, Beam Studio exclourà automàticament aquests objectes durant l'exportació. Encara pots desar el teu projecte dins de l'escena de Beam Studio (format .beam) per mantenir totes les teves dades. Encara vols exportar?",
    learn_more: 'Saber-ne més',
    login_first: 'Inicia sessió per desbloquejar la base de dades de formes.',
    recent: 'Recent',
    search: 'Cercar',
    shapes: 'Formes',
  },
  pass_through: {
    export: 'Exportar a àrea de treball',
    exporting: 'Exportant...',
    guide_mark: 'Marca guia',
    guide_mark_desc: "Les marques guia es gravaran com a punt de referència per alinear l'obra.",
    guide_mark_length: 'Longitud:',
    guide_mark_x: 'Coordenada X:',
    height_desc: "Estableix l'alçada de cada secció de l'àrea de treball.",
    help_links: {
      ado1: 'https://support.flux3dp.com/hc/en-us/articles/10140002160399',
      fbb2: 'https://support.flux3dp.com/hc/en-us/articles/11570021253263',
    },
    help_text: 'Com configurar Pas a través per a %(model)s?',
    object_length: 'Longitud objecte',
    ref_layer: 'Capa de referència',
    ref_layer_desc: "Si us plau, tingues en compte que l'execució de la capa de referència està establerta a 0 per defecte. No s'executarà, sinó que és només per a referència d'alineació.",
    ref_layer_name: 'Referència',
    title: 'Mode pas a través',
    workarea_height: 'Àrea de treball (Alçada):',
  },
  promark_connection_test: {
    description: 'El sistema executarà una operació de llum vermella durant uns dos minuts per comprovar si la connexió és estable.',
    health: 'Estabilitat:',
    healthy_description: "L'estabilitat és bona, però evita moure l'ordinador significativament durant el gravat.",
    res_0: 'Excel·lent',
    res_1: 'Bo',
    res_2: 'Baix',
    res_3: 'Massa baix',
    res_4: 'Molt baix',
    restart: 'Reiniciar prova',
    start: 'Iniciar prova',
    stop: 'Aturar prova',
    title: "Prova d'estabilitat de connexió",
    unhealthy_description: "L'estabilitat és massa baixa. Es recomana substituir l'adaptador de xarxa o el cable d'alimentació.",
  },
  promark_settings: {
    angle: 'Angle',
    bulge: 'Protuberància',
    field: 'Camp',
    galvo_configuration: 'Configuració Galvo',
    mark: 'Marca',
    mark_parameters: 'Paràmetres de marca',
    offsetX: 'Desplaçament X',
    offsetY: 'Desplaçament Y',
    red_dot: 'Punt vermell',
    scale: 'Escala',
    scaleX: 'Escala X',
    scaleY: 'Escala Y',
    skew: 'Biaix',
    switchXY: 'Canviar X/Y',
    title: 'Configuració de Promark',
    trapezoid: 'Trapezi',
    workarea_hint: 'Pots canviar l\'àrea de treball a "Configuració del document"',
    z_axis_adjustment: {
      section1: "Ajusta l'alçada de l'eix Z per afinar l'enfocament.",
      title: "Ajust de l'eix Z",
      tooltip1: "Prova de marcar un quadrat d'1x1 cm per confirmar si la distància focal actual és adequada.",
    },
  },
  qr_code_generator: {
    error_tolerance: "Tolerància d'error",
    error_tolerance_link: 'https://support.flux3dp.com/hc/en-us/articles/9113705072143',
    invert: 'Invertir color de fons',
    placeholder: 'Introdueix un enllaç o text',
    title: 'Generador de codi QR',
  },
  resolution: {
    title: 'Resolució',
    values: {
      detailed: 'Detallat',
      high: 'Alt',
      low: 'Baix',
      medium: 'Mitjà',
      ultra: 'Ultra alt',
    },
  },
  rotary_settings: {
    circumference: 'Circumferència',
    extend_workarea: 'Estendre àrea de treball',
    mirror: 'Mirall',
    object_diameter: 'Diàmetre objecte',
    overlap_size: 'Mida superposició',
    rotary_scale: 'Escala de rotació',
    split_setting: 'Configuració de divisió',
    split_setting_url: 'https://support.flux3dp.com/hc/en-us/articles/12276094010767',
    split_size: 'Mida de divisió',
    type: 'Tipus',
  },
  select_device: {
    auth_failure: "#811 Error d'autenticació",
    select_device: 'Selecciona dispositiu',
    unable_to_connect: '#810 No es pot establir una connexió estable amb la màquina',
  },
  settings: {
    anti_aliasing: 'Anti-Aliasing',
    auto_connect: "Seleccionar automàticament l'única màquina",
    auto_switch_tab: 'Canvi automàtic panell Capa i Objecte',
    autofocus_offset: 'Desplaçament enfocament automàtic',
    autosave_enabled: 'Desament automàtic',
    autosave_interval: 'Desar cada',
    autosave_number: 'Nombre de desaments automàtics',
    autosave_path: 'Ubicació de desament automàtic',
    autosave_path_not_correct: 'Ruta especificada no trobada.',
    blade_precut_position: 'Posició pretall',
    blade_precut_switch: 'Pretall fulla',
    blade_radius: 'Radi fulla',
    bottom_up: 'De baix a dalt',
    calculation_optimization: 'Acceleració càlcul camí',
    cancel: 'Cancel·lar',
    caption: 'Configuració',
    check_updates: 'Comprovar actualitzacions automàticament',
    close: 'Tancar',
    confirm_remove_default: "La màquina per defecte s'eliminarà.",
    confirm_reset: 'Confirmar restablir Beam Studio?',
    continuous_drawing: 'Dibuix continu',
    crop_task_thumbnail: 'Miniatura retall contingut',
    crop_task_thumbnail_tooltip: "Mostra només la miniatura de l'àrea que conté contingut, excloent les àrees de llenç en blanc.",
    custom_preview_height: 'Alçada vista prèvia personalitzada',
    default_beambox_model: 'Configuració document per defecte',
    default_borderless_mode: 'Per defecte fons obert',
    default_enable_autofocus_module: 'Per defecte enfocament automàtic',
    default_enable_diode_module: 'Per defecte làser de díode',
    default_font_family: 'Font per defecte',
    default_font_style: 'Estil font per defecte',
    default_laser_module: 'Mòdul làser per defecte',
    default_machine: 'Màquina per defecte',
    default_machine_button: 'Buit',
    default_units: 'Unitats per defecte',
    diode_offset: 'Desplaçament làser de díode',
    diode_one_way_engraving: 'Gravat unidireccional làser de díode',
    diode_two_way_warning: "L'emissió de llum bidireccional és més ràpida i probablement generi certa imprecisió en la posició de gravat làser. Es recomana provar primer.",
    disabled: 'Deshabilitat',
    done: 'Aplicar',
    enable_custom_backlash: 'Habilitar compensació de joc personalitzada',
    enable_low_speed: 'Habilitar moviment de baixa velocitat',
    enable_uv_print_file: "Habilitar fitxer d'impressió UV",
    enabled: 'Habilitat',
    engraving_direction: 'Direcció',
    engraving_offset_tooltip: "Si el resultat del gravat es desplaça cap a l'esquerra o cap amunt, si us plau disminueix el desplaçament X/Y; si es desplaça cap a la dreta o cap avall, si us plau augmenta el desplaçament X/Y.",
    fast_gradient: 'Optimització de velocitat',
    font_convert: 'Convertidor Text a Traçat',
    font_substitute: 'Substituir caràcters no compatibles',
    grouped_objects: 'Objectes agrupats',
    groups: {
      ador_modules: 'Mòduls Ador',
      autosave: 'Desament automàtic',
      beamo2_modules: 'Mòduls beamo 2',
      camera: 'Càmera',
      connection: 'Connexió',
      editor: 'Editor',
      engraving: 'Rasterització (Escaneig)',
      general: 'General',
      mask: 'Retall àrea treball',
      module_settings: 'Configuració del mòdul',
      module_type: 'Mòdul de màquina',
      modules: 'Complement',
      path: 'Vector (Contorns)',
      performance: 'Rendiment',
      privacy: 'Privadesa',
      text: 'Text',
      text_to_path: 'Text',
      update: 'Actualitzacions de programari',
      workarea: 'Àrea de treball',
    },
    guess_poke: 'Cercar adreça IP de màquina',
    guides: 'Guies',
    guides_origin: 'Origen de guies',
    help_center_urls: {
      anti_aliasing: 'https://support.flux3dp.com/hc/en-us/articles/360004408956',
      calculation_optimization: 'https://support.flux3dp.com/hc/en-us/articles/11146997425039',
      connection: 'https://support.flux3dp.com/hc/en-us/sections/360000302135',
      continuous_drawing: 'https://support.flux3dp.com/hc/en-us/articles/360004406496',
      default_borderless_mode: 'https://support.flux3dp.com/hc/zh-tw/articles/360001104076',
      default_enable_autofocus_module: 'https://support.flux3dp.com/hc/en-us/articles/360001574536',
      default_enable_diode_module: 'https://support.flux3dp.com/hc/en-us/articles/360001568035',
      fast_gradient: 'https://support.flux3dp.com/hc/en-us/articles/360004496235',
      font_convert: 'https://support.flux3dp.com/hc/en-us/articles/9132766761743',
      font_substitute: 'https://support.flux3dp.com/hc/en-us/articles/360004496575',
      image_downsampling: 'https://support.flux3dp.com/hc/en-us/articles/360004494995',
      loop_compensation: 'https://support.flux3dp.com/hc/en-us/articles/360004408856',
      mask: 'https://support.flux3dp.com/hc/en-us/articles/360004408876',
      reverse_engraving: 'https://support.flux3dp.com/hc/en-us/articles/',
      segmented_engraving: 'https://support.flux3dp.com/hc/en-us/articles/12306366019215',
      simplify_clipper_path: 'https://support.flux3dp.com/hc/en-us/articles/360004407276',
      uv_print_export: 'https://support.flux3dp.com/hc/en-us/articles/12320887477135',
      vector_speed_constraint: 'https://support.flux3dp.com/hc/en-us/articles/360004496495',
    },
    high: 'Alt',
    image_downsampling: 'Qualitat vista prèvia mapa bits',
    ip: 'Adreça IP màquina',
    keep_preview_result: 'Mantenir resultat vista prèvia',
    language: 'Idioma',
    loop_compensation: 'Compensació de bucle',
    low: 'Baix',
    low_laser_for_preview: 'Làser per a marc en execució',
    mask: 'Retall àrea treball',
    medium: 'Mitjà',
    module_offset_2w_ir: 'Desplaçament làser infraroig 2W',
    module_offset_10w: 'Desplaçament làser de díode 10W',
    module_offset_20w: 'Desplaçament làser de díode 20W',
    module_offset_laser: 'Desplaçament làser',
    module_offset_printer: 'Desplaçament impressora',
    none: 'Cap',
    normal: 'Normal',
    notification_off: 'Desactivat',
    notification_on: 'Activat',
    notifications: "Notificacions d'escriptori",
    off: 'Desactivat',
    on: 'Activat',
    preview_movement_speed: 'Velocitat moviment vista prèvia',
    printer_advanced_mode: 'Mode avançat impressora',
    printing_offset_tooltip: "Si el resultat d'impressió es desplaça cap a l'esquerra o amunt, si us plau disminueix el desplaçament X/Y; quan es desplaça cap a la dreta o avall, si us plau augmenta el desplaçament X/Y.",
    remove_default_machine_button: 'Eliminar',
    reset: 'Restablir Beam Studio',
    reset_now: 'Restablir Beam Studio',
    segmented_engraving: 'Gravat segmentat',
    share_with_flux: 'Compartir analítiques Beam Studio',
    show_banners: "Mostra el banner d'inici",
    simplify_clipper_path: "Optimització de punts d'ancoratge",
    single_object: 'Objecte únic',
    tabs: {
      device: 'Màquina',
      general: 'General',
    },
    text_path_calc_optimization: 'Optimització càlcul camí',
    top_down: 'De dalt a baix',
    trace_output: 'Sortida traçat imatge',
    update_beta: 'Beta',
    update_latest: 'Últim',
    use_real_boundary: 'Utilitzar rang màxim',
    use_real_boundary_tooltip: "Expandir a l'àrea de treball màxima real, sense restriccions per línies de quadrícula enteres.",
    use_union_boundary: 'Mostrar àrea de treball superposada',
    use_union_boundary_tooltip: 'Mostra àrees de treball superposades de múltiples mòduls',
    vector_speed_constraint: 'Límit de velocitat',
    wrong_ip_format: 'Formats IP incorrectes',
  },
  social_media: {
    facebook: 'Xateja amb FLUXers, fes preguntes i aprèn trucs!',
    instagram: 'Obtén les últimes inspiracions, ofertes i regals!',
    youtube: "Veure tutorials de Beam Studio i idees d'artesania.",
  },
  stamp_maker_panel: {
    bevel_radius: 'Radi de bisell',
    horizontal_flip: 'Gir horitzontal',
    how_to: {
      text: 'Com fer un segell?',
      url: 'https://support.flux3dp.com/hc/en-us/articles/13658787903247',
    },
    invert: 'Invertir',
    title: 'Fabricant de segells',
  },
  support: {
    no_vcredist: 'Si us plau, instal·la Visual C++ Redistributable 2015<br/>Que es pot descarregar a flux3dp.com',
    no_webgl: 'WebGL no és compatible. Si us plau, utilitza altres dispositius.',
  },
  tab_panel: {
    apply: 'Aplicar pestanyes',
    gap: 'Espai',
    help_center: 'https://support.flux3dp.com/hc/en-us/articles/12441363882511',
    manual_mode: 'Mode manual',
    title: 'Pestanyes',
    width: 'Amplada',
  },
  topbar: {
    alerts: {
      add_content_first: 'Si us plau, afegeix objectes primer',
      close_door_before_framing: "Si us plau, tanca la porta abans de començar la vista prèvia d'emmarcat.",
      door_opened: 'Si us plau, tanca la coberta de la porta per habilitar làser baix per a marc en execució.',
      fail_to_connect_with_camera: '#803 Error en establir connexió amb la càmera de la màquina. Si us plau, reinicia la teva màquina o Beam Studio. Si aquest error persisteix, si us plau segueix <a target="_blank" href="https://flux3dp.zendesk.com/hc/en-us/articles/360001791895">aquesta guia</a>.',
      fail_to_get_door_status: "Si us plau, assegura't que la coberta de la porta estigui tancada per habilitar làser baix per a marc en execució.",
      fail_to_start_preview: '#803 Error en iniciar mode vista prèvia. Si us plau, reinicia la teva màquina o Beam Studio. Si aquest error persisteix, si us plau segueix <a target="_blank" href="https://flux3dp.zendesk.com/hc/en-us/articles/360001791895">aquesta guia</a>.',
      headtype_mismatch: 'Mòdul incorrecte detectat. ',
      headtype_none: 'Mòdul no detectat. ',
      headtype_unknown: 'Mòdul desconegut detectat. ',
      install_correct_headtype: 'Si us plau, instal·la correctament els mòduls làser de díode 10W/20W per habilitar làser baix per a marc en execució.',
      job_origin_unavailable: "Establir l'origen del treball requereix versió de firmware 4.3.5 / 5.3.5 o superior. Vols actualitzar el firmware ara?",
      job_origin_warning: "Actualment estàs utilitzant la “posició actual” com a punt de partida. Si us plau, assegura't que el capçal làser es mogui a la posició correcta per evitar col·lisions.",
      object_outside_moving_area: "Alguns objectes estan fora de l'àrea límit de vista prèvia.",
      power_too_high: 'POTÈNCIA MASSA ALTA',
      power_too_high_confirm: 'NOTAT',
      power_too_high_msg: 'Utilitzar una potència làser més baixa (menys del 70%) allargarà la vida útil del tub làser.\nIntrodueix "NOTAT" per procedir.',
      pwm_unavailable: 'El mode profunditat requereix versió de firmware 4.3.4 / 5.3.4 o superior. Vols actualitzar el firmware ara?',
      QcleanScene: 'Vols esborrar el dibuix?<br/>Això també esborrarà el teu historial de desfer!',
      start_preview_timeout: '#803 S\'ha produït un temps d\'espera en iniciar el mode vista prèvia. Si us plau, reinicia la teva màquina o Beam Studio. Si aquest error persisteix, si us plau segueix <a target="_blank" href="https://flux3dp.zendesk.com/hc/en-us/articles/360001791895">aquesta guia</a>.',
      variable_text_warning: "Aquest treball conté text variable. El sistema prioritzarà gravar el contingut de text variable i no seguirà l'ordre de capes.",
    },
    frame_task: 'Marc en execució',
    hint: {
      polygon: 'Prem tecla + / - per augmentar / disminuir costats.',
    },
    menu: {
      about: 'Sobre Beam Studio',
      about_beam_studio: 'Sobre Beam Studio',
      account: 'Compte',
      add_new_machine: 'Configuració de màquina',
      align_center: 'Alinear al centre',
      anti_aliasing: 'Anti-Aliasing',
      auto_align: 'Alineació automàtica',
      autofocus: {
        operating: 'Enfocant automàticament...',
        select_device_error: "Si us plau, selecciona un dispositiu abans d'enfocar automàticament.",
        show_probe_error: "Si us plau, mostra la sonda abans d'enfocar automàticament.",
        title: 'Enfocament automàtic',
      },
      borderless_mode: 'Mode sense vores',
      bug_report: "Informe d'errors",
      calibrate_beambox_camera: 'Calibrar càmera',
      calibrate_beambox_camera_borderless: 'Calibrar càmera (Fons obert)',
      calibrate_camera_advanced: 'Calibrar càmera (Avançat)',
      calibrate_diode_module: 'Calibrar mòdul làser de díode',
      calibrate_ir_module: 'Calibrar mòdul infraroig',
      calibrate_printer_module: "Calibrar mòdul d'impressió",
      calibrate_wide_angle_camera: 'Calibrar càmera (Càmera gran angular)',
      calibration: 'Calibratge',
      camera_calibration_data: 'Dades de calibratge de càmera',
      change_logs: 'Registres de canvis',
      clear_scene: 'Nou',
      close: 'Tancar finestra',
      commands: 'Comandes',
      contact: 'Contacta amb nosaltres',
      copy: 'Copiar',
      cut: 'Retallar',
      dashboard: 'Tauler',
      decompose_path: 'Descompondre',
      delete: 'Eliminar',
      design_market: 'Mercat de disseny',
      dev_tool: 'Eina de depuració',
      disassemble_use: 'Desmuntar',
      document_setting: 'Configuració del document',
      document_setting_short: 'Document',
      download_data: 'Descarregar dades',
      download_log: 'Descarregar registres',
      download_log_canceled: 'Descàrrega de registre cancel·lada',
      download_log_error: "S'ha produït un error desconegut, si us plau torna-ho a provar més tard",
      duplicate: 'Duplicar',
      edit: 'Edita',
      example_files: "Fitxers d'exemple",
      export_BVG: 'BVG',
      export_flux_task: 'Tasca FLUX',
      export_JPG: 'JPG',
      export_PNG: 'PNG',
      export_SVG: 'SVG',
      export_to: 'Exportar a...',
      export_UV_print: 'PDF Impressió UV',
      file: 'Fitxer',
      fit_to_window: 'Ajustar a mida de finestra',
      follow_us: 'Segueix-nos',
      forum: 'Fòrum comunitari',
      group: 'Agrupar',
      help: 'Ajuda',
      help_center: "Centre d'ajuda",
      hide: 'Amagar Beam Studio',
      hideothers: 'Amagar altres',
      image_crop: 'Retallar',
      image_curve: 'Corba',
      image_invert: 'Invertir',
      image_sharpen: 'Afilar',
      image_stamp: 'Bisel',
      image_vectorize: 'Traçar',
      import_acrylic_focus_probe: "Sonda d'enfocament acrílic - 3mm",
      import_ador_laser_example: 'Exemple de làser Ador',
      import_ador_printing_example_full: "Exemple d'impressió Ador - Tot color",
      import_ador_printing_example_single: "Exemple d'impressió Ador - Color únic",
      import_beambox_2_example: 'Exemple de Beambox II',
      import_beambox_2_focus_probe: "Sonda d'enfocament Beambox II - 3mm",
      import_beamo_2_laser_example: 'Exemple de làser beamo II',
      import_beamo_2_printing_example: "Exemple d'impressió beamo II",
      import_hello_beambox: 'Exemple de Beambox',
      import_hello_beamo: 'Exemple de beamo',
      import_hexa_example: 'Exemple de HEXA',
      import_hexa_rf_example: 'Exemple de HEXA RF',
      import_material_printing_test: "Prova d'impressió de material",
      import_material_testing_cut: 'Prova de tall de material',
      import_material_testing_engrave: 'Prova de gravat de material',
      import_material_testing_line: 'Prova de línia de material',
      import_material_testing_old: 'Prova de gravat de material - Clàssic',
      import_material_testing_simple_cut: 'Prova de tall de material - Simple',
      import_promark_example: 'Exemple de Promark',
      import_promark_mopa_20w_color: 'Prova de color MOPA 20W',
      import_promark_mopa_60w_color: 'Prova de color MOPA 60W',
      import_promark_mopa_100w_color: 'Prova de color MOPA 100W',
      keyboard_shortcuts: 'Dreceres de teclat',
      layer_color_config: 'Configuració de color',
      layer_setting: 'Capa',
      link: {
        beam_studio_api: 'https://github.com/flux3dp/beam-studio/wiki/Beam-Studio-Easy-API',
        contact_us: 'https://flux3dp.zendesk.com/hc/en-us/requests/new',
        design_market: 'https://dmkt.io',
        downloads: 'https://flux3dp.com/downloads/',
        forum: 'https://www.facebook.com/groups/flux.laser/',
        help_center: 'https://helpcenter.flux3dp.com/',
        shortcuts: 'https://support.flux3dp.com/hc/en-us/articles/10003978157455',
      },
      log: {
        camera: 'Càmera',
        cloud: 'Núvol',
        discover: 'Descobrir',
        hardware: 'Maquinari',
        network: 'Xarxa',
        player: 'Reproductor',
        robot: 'Robot',
        usb: 'USB',
        usblist: 'Llista USB',
      },
      login_or_register: "Inicia sessió o Registra't",
      logout: 'Tancar sessió',
      machine_info: 'Informació de màquina',
      machines: 'Màquines',
      manage_account: 'Gestionar el meu compte',
      material_test: 'Prova de material',
      minimize: 'Minimitzar',
      my_account: 'El meu compte',
      network_testing: 'Provar configuració de xarxa',
      object: 'Objecte',
      offset: 'Desplaçament',
      open: 'Obrir',
      paste: 'Enganxar',
      paste_in_place: 'Enganxar al lloc',
      path: 'Traçat',
      photo_edit: 'Imatge',
      preferences: 'Preferències',
      promark_color_test: 'Prova de color Promark',
      questionnaire: 'Qüestionari de retroalimentació',
      quit: 'Sortir',
      recent: 'Obrir recent',
      redo: 'Refer',
      reload_app: 'Recarregar aplicació',
      reset: 'Restablir',
      rotary_setup: 'Configuració rotatòria',
      rotate: 'Rotar',
      samples: 'Exemples',
      save_as: 'Desar com...',
      save_scene: 'Desar',
      save_to_cloud: 'Desar al núvol',
      scale: 'Escala',
      service: 'Serveis',
      set_as_default: 'Establir com a predeterminat',
      show_gesture_tutorial: 'Introducció gest manual',
      show_grids: 'Mostrar graelles',
      show_layer_color: 'Utilitzar color de capa',
      show_rulers: 'Mostrar regles',
      show_start_tutorial: "Mostrar tutorial d'inici",
      show_ui_intro: 'Mostrar introducció interfície',
      software_update: 'Actualització de programari',
      svg_edit: 'SVG',
      switch_to_beta: 'Canviar a versió Beta',
      switch_to_latest: 'Canviar a versió estable',
      tools: {
        title: 'Eines',
      },
      tutorial: 'Iniciar tutorial impressió família Delta',
      undo: 'Desfer',
      ungroup: 'Desagrupar',
      update: 'Comprovar actualització',
      update_firmware: 'Actualitzar firmware',
      update_machine: 'Actualitzar màquina',
      update_mainboard: 'Actualitzar placa base',
      update_printer_board: 'Actualitzar placa impressora',
      upload_data: 'Pujar dades',
      using_beam_studio_api: 'Utilitzant API Beam Studio',
      view: 'Veure',
      window: 'Finestra',
      zoom_in: 'Apropar',
      zoom_out: 'Allunyar',
      zoom_with_window: 'Ajust automàtic a mida finestra',
    },
    rename_tab: 'Reanomenar pestanya',
    select_machine: 'Selecciona una màquina',
    tag_names: {
      dxf: 'Objecte DXF',
      ellipse: 'Oval',
      g: 'Grup',
      image: 'Imatge',
      line: 'Línia',
      multi_select: 'Múltiples objectes',
      no_selection: 'Cap selecció',
      pass_through_object: 'Objecte de pas a través',
      path: 'Traçat',
      polygon: 'Polígon',
      rect: 'Rectangle',
      svg: 'Objecte SVG',
      text: 'Text',
      text_path: 'Text en traçat',
      use: 'Objecte importat',
    },
    task_preview: 'Vista prèvia de traçat',
    titles: {
      settings: 'Preferències',
    },
    untitled: 'Sense títol',
  },
  topmenu: {
    credit: 'Beam Studio és possible gràcies al projecte de codi obert <a target="_blank" href="https://github.com/flux3dp/beam-studio">Beam Studio</a> i altre <a target="_blank" href="https://flux3dp.com/credits/">programari de codi obert</a>.',
    device: {
      download_log_canceled: 'Descàrrega de registre cancel·lada',
      download_log_error: "S'ha produït un error desconegut, si us plau torna-ho a provar més tard",
      log: {
        usblist: 'Llista USB',
      },
      network_test: 'Provar xarxa',
    },
    file: {
      all_files: 'Tots els fitxers',
      clear_recent: 'Esborrar oberts recentment',
      converting: 'Convertint a imatge...',
      fcode_files: 'Codi FLUX',
      import: 'Importar',
      jpg_files: 'JPG',
      label: 'Fitxer',
      path_not_exit: 'Aquesta ruta no sembla existir més al disc.',
      png_files: 'PNG',
      save_fcode: 'Exportar tasca FLUX',
      save_jpg: 'Exportar JPG',
      save_pdf: 'Exportar PDF',
      save_png: 'Exportar PNG',
      save_scene: 'Desar escena',
      save_svg: 'Exportar SVG',
      scene_files: 'Escena Beam Studio',
      svg_files: 'SVG',
    },
    version: 'Versió',
  },
  tutorial: {
    ask_retry_calibration: 'Vols tornar a calibrar la càmera?',
    camera_calibration_failed: 'Calibratge de càmera fallit',
    gesture: {
      click: "Toca per seleccionar l'objecte.",
      drag: 'Arrossega per seleccionar múltiples objectes.',
      hold: 'Prem i mantén per obrir el menú contextual.',
      pan: 'Desplaça el llenç amb dos dits.',
      zoom: 'Pessiga amb dos dits per apropar/allunyar el llenç.',
    },
    links: {
      adjust_focus: 'https://flux3dp.zendesk.com/hc/en-us/articles/360001684196',
    },
    look_for_machine: 'Cercant màquina per tutorial...',
    needNewInterfaceTutorial: 'Vols començar un tutorial per a la nova interfície de Beam Studio?<br/>(Pots saltar-lo ara i començar-lo més tard fent clic a "Ajuda" > "Mostrar introducció interfície".)',
    needNewUserTutorial: 'Vols començar un tutorial?<br/>(Pots saltar-lo ara i començar-lo més tard fent clic a "Ajuda" > "Mostrar tutorial d\'inici".)',
    newInterface: {
      add_new_layer: 'Afegir nova capa',
      align_controls: "Controls d'alineació",
      basic_shapes: 'Formes bàsiques',
      camera_preview: 'Vista prèvia de càmera',
      drag_to_sort: 'Arrossega per ordenar',
      end_alert: "Estàs segur d'acabar la introducció de la nova IU?",
      flip: 'Girar',
      group_controls: 'Controls de grup',
      layer_controls: 'Clic dret per seleccionar Controls de capa:\nDuplicar / Fusionar / Bloquejar / Eliminar Capes',
      object_actions: "Accions d'objecte",
      pen_tool: 'Eina bolígraf',
      rename_by_double_click: 'Reanomenar per doble clic',
      select_image_text: 'Seleccionar / Imatge / Text',
      select_machine: 'Selecciona una màquina',
      shape_operation: 'Operació de forma',
      start_work: 'Començar treball',
      switch_between_layer_panel_and_object_panel: "Canviar entre Panell de Capa i Panell d'Objecte",
    },
    newUser: {
      add_new_layer: 'Afegir una nova capa',
      adjust_focus: "2. Ajusta l'enfocament",
      close_cover: '3. Tanca la coberta',
      drag_to_draw: 'Arrossega per dibuixar',
      draw_a_circle: 'Dibuixa un cercle',
      draw_a_rect: 'Dibuixa un rectangle',
      end_alert: "Estàs segur d'acabar el tutorial?",
      end_preview_mode: 'Finalitzar mode vista prèvia',
      infill: 'Activar farciment',
      please_select_wood_cutting: 'Amablement selecciona el preestablert "Fusta - Tall".',
      please_select_wood_engraving: 'Amablement selecciona el preestablert "Fusta - Gravat".',
      preview_the_platform: 'Previsualitzar la plataforma',
      put_wood: '1. Posa la fusta de mostra',
      send_the_file: 'Enviar el fitxer',
      set_preset_wood_cut: 'Establir preestablert: Fusta - Tall',
      set_preset_wood_engraving: 'Establir preestablert: Fusta - Gravat',
      start_tutorial: 'Començar tutorial',
      switch_to_layer_panel: 'Canviar a Panell de Capa',
      switch_to_object_panel: "Canviar a Panell d'Objecte",
      switch_to_preview_mode: 'Canviar a Mode Vista Prèvia',
    },
    next: 'SEGÜENT',
    retry: 'Reintentar',
    set_connection: 'Establir connexió',
    skip: 'Saltar',
    skip_tutorial: 'Has saltat el tutorial. Sempre pots començar el tutorial fent clic a "Ajuda" > "Mostrar tutorial d\'inici"',
    suggest_calibrate_camera_first: 'Aconsellem als usuaris calibrar la càmera inicialment i reenfocar abans de cada vista prèvia per a resultats òptims.<br/>Si us plau confirma per realitzar el calibratge ara?<br/>(Pots saltar-lo ara i fer-lo més tard fent clic a "Menú" > "Màquina" > [La teva màquina] > "Calibrar càmera".)',
    tutorial_complete: 'Això és tot per al tutorial. Ara és hora de crear!',
    unable_to_find_machine: 'No es pot trobar màquina per al Tutorial. Vols anar a la pàgina de configuració de connexió, reintentar o saltar el tutorial?',
    welcome: 'BENVINGUT',
  },
  update: {
    cannot_reach_internet: '#823 El servidor és inaccessible<br/>Si us plau comprovant connexió a internet',
    download: 'ACTUALITZACIÓ EN LÍNIA',
    firmware: {
      caption: 'Hi ha una actualització de Firmware disponible per a la màquina',
      confirm: 'PUJAR',
      firmware_too_old_update_by_sdcard: 'La versió del firmware és massa antiga. Si us plau, actualitza el firmware utilitzant una targeta SD.',
      force_update_message: "#814 Si us plau, actualitza la teva màquina a l'última versió de firmware.",
      latest_firmware: {
        cant_get_latest: "No es pot obtenir informació de l'últim firmware.",
        caption: 'Actualització de firmware de màquina',
        message: "Tens l'últim firmware de màquina",
        still_update: 'ACTUALITZAR',
      },
      message_pattern_1: '"%s" ja està llest per a l\'actualització de firmware.',
      message_pattern_2: '%s Firmware v%s ja està disponible - Tens v%s.',
      too_old_for_web: "La teva versió actual de firmware de màquina és v%s.\nSi vols utilitzar la versió en línia de Beam Studio, si us plau actualitza el firmware de la màquina a l'última versió.",
      update_fail: '#822 Actualització fallida',
      update_success: 'Actualització de firmware pujada amb èxit',
      upload_firmware_title: 'Pujada de firmware (*.fxfw)',
      upload_mainboard_title: 'Pujada de firmware de placa base (*.bin)',
      upload_printer_board_title: 'Pujada de firmware de placa impressora (*.bin)',
    },
    install: 'INSTAL·LAR',
    later: 'MÉS TARD',
    preparing: 'Preparant...',
    release_note: 'Nota de llançament:',
    skip: 'Saltar aquesta versió',
    software: {
      available_switch: 'Beam Studio v%s ja està disponible. Tens v%s. Vols canviar a aquesta versió?',
      available_update: "Beam Studio v%s ja està disponible. Tens v%s. Vols descarregar l'actualització?",
      caption: 'Hi ha una actualització de programari disponible per a Beam Studio',
      check_update: 'Comprovar actualització',
      checking: 'Comprovant actualització',
      downloading: 'Descarregant actualitzacions en segon pla, pots fer clic a "D\'acord" per continuar el teu treball.',
      install_or_not: "està llest per a l'actualització. T'agradaria reiniciar i actualitzar ara?",
      no: 'No',
      no_response: 'Error en connectar al servidor, si us plau comprova la teva configuració de xarxa.',
      not_found: "Estàs utilitzant l'última versió de Beam Studio.",
      switch_or_not: "està llest per al canvi. T'agradaria reiniciar i canviar ara?",
      switch_version: 'Canviar versió',
      switch_version_not_found: 'Versió canviable no trobada.',
      update_for_ador: "La versió actual del programari %s és incompatible, si us plau descarrega l'última versió de Beam Studio per a Ador.",
      yes: 'Sí',
    },
    update: 'Actualitzar',
    updating: 'Actualitzant...',
    upload: 'PUJAR',
  },
  variable_text_settings: {
    advance_by: 'Avançar per',
    auto_advance: 'Avanç automàtic',
    auto_advance_hint: 'Avança automàticament a les següents dades variables cada vegada que executes un treball.',
    bake: 'Finalitzar',
    bake_description: 'Esborrar variabilitat i convertir a text regular',
    browse: 'Explorar',
    clear: 'Esborrar',
    csv_file: 'Fitxer CSV',
    current: 'Actual',
    end: 'Fi',
    failed_to_convert: "L'objecte de text variable conté un format no compatible, que pot causar que el contingut no es mostri.",
    file_error: 'Error al analitzar fitxer CSV, si us plau comprova el format del fitxer.',
    file_size_exceeded: 'Pujada de fitxer fallida, la mida del fitxer supera els 5MB.',
    next: 'Següent',
    note: "Aquesta configuració s'aplicarà automàticament a tots els textos variables",
    previous: 'Anterior',
    start: 'Inici',
    test: 'Prova',
    test_description: 'Prem i mantén per veure text variable',
    title: 'Configuració de textos variables',
  },
  web_cam: {
    image_to_small: 'La mida de la imatge de la càmera és massa petita. La imatge pot estar corrupta.',
    no_device: 'No es pot detectar el dispositiu de càmera. Si us plau, reconnecta la càmera i torna-ho a provar.',
    no_permission: "Beam Studio no té permís per accedir a la càmera. Si us plau, assegura't que el permís estigui concedit a Beam Studio a la configuració del sistema o del navegador.",
  },
  welcome_page: {
    follow_us: {
      subtitle: 'Obtén inspiracions, ofertes, regals i interactua amb FLUXers!',
      user_group: "Grup d'usuaris",
    },
    help_center: {
      guides: 'Guies',
      guides_subtitle: 'Veure guies completes per a tots els productes FLUX.',
      submit_request: 'Enviar una sol·licitud',
      subtitle: 'Guies, manuals i recursos de suport per a tot allò relacionat amb FLUX.',
      visit_help_center: "Visitar Centre d'ajuda",
    },
    member_center: 'Centre de membres',
    member_center_url: 'https://member.flux3dp.com/en-US/machine-register',
    new_project: 'Nou projecte',
    not_login_placeholder: 'Aconsegueix crèdits IA gratuïts quan et registris per a un compte FLUX!',
    recent_files: 'Fitxers recents',
    shop: 'Botiga',
    shop_products: 'Comprar productes FLUX',
  },
  z_speed_limit_test: {
    alert_before: "Abans de començar el gravat corbat, el sistema realitzarà una prova de càrrega per evitar pèrdua de pas a causa d'un pes excessiu.",
    alert_failed: "El pes de l'objecte actual supera el límit de càrrega per a la velocitat actual de l'eix Z. Si us plau, redueix la velocitat de l'eix Z al panell de la màquina o substitueix l'objecte de gravat abans de tornar a provar.",
    ignore: 'Ignorar',
    retest: 'Tornar a provar',
    testing: 'Realitzant prova de càrrega...',
  },
};

export default lang;
